/** Curated offline website interface translations: German source -> 10 selectable languages. */
export type SiteLocale = "en" | "ta" | "si" | "hi" | "ar" | "tr" | "ru" | "zh" | "fr" | "es";
export const siteTranslations: Record<string, Record<SiteLocale, string>> = {
  "Sprache": {
    "en": "Language",
    "ta": "மொழி",
    "si": "භාෂාව",
    "hi": "भाषा",
    "ar": "اللغة",
    "tr": "Dil",
    "ru": "Язык",
    "zh": "语言",
    "fr": "Langue",
    "es": "Idioma"
  },
  "Kurs": {
    "en": "Course",
    "ta": "பாடநெறி",
    "si": "පාඨමාලාව",
    "hi": "पाठ्यक्रम",
    "ar": "الدورة",
    "tr": "Kurs",
    "ru": "Курс",
    "zh": "课程",
    "fr": "Cours",
    "es": "Curso"
  },
  "Kurse": {
    "en": "Courses",
    "ta": "பாடநெறிகள்",
    "si": "පාඨමාලා",
    "hi": "पाठ्यक्रम",
    "ar": "الدورات",
    "tr": "Kurslar",
    "ru": "Курсы",
    "zh": "课程",
    "fr": "Cours",
    "es": "Cursos"
  },
  "Bücher": {
    "en": "Books",
    "ta": "புத்தகங்கள்",
    "si": "පොත්",
    "hi": "पुस्तकें",
    "ar": "الكتب",
    "tr": "Kitaplar",
    "ru": "Книги",
    "zh": "图书",
    "fr": "Livres",
    "es": "Libros"
  },
  "Kontakt": {
    "en": "Contact",
    "ta": "தொடர்பு",
    "si": "සම්බන්ධ වන්න",
    "hi": "संपर्क",
    "ar": "اتصل بنا",
    "tr": "İletişim",
    "ru": "Контакты",
    "zh": "联系",
    "fr": "Contact",
    "es": "Contacto"
  },
  "Datenschutzerklärung": {
    "en": "Privacy policy",
    "ta": "தனியுரிமைக் கொள்கை",
    "si": "පෞද්ගලිකත්ව ප්‍රතිපත්තිය",
    "hi": "गोपनीयता नीति",
    "ar": "سياسة الخصوصية",
    "tr": "Gizlilik politikası",
    "ru": "Политика конфиденциальности",
    "zh": "隐私政策",
    "fr": "Politique de confidentialité",
    "es": "Política de privacidad"
  },
  "Nutzungsbedingungen": {
    "en": "Terms of service",
    "ta": "பயன்பாட்டு விதிமுறைகள்",
    "si": "සේවා කොන්දේසි",
    "hi": "सेवा की शर्तें",
    "ar": "شروط الاستخدام",
    "tr": "Kullanım koşulları",
    "ru": "Условия использования",
    "zh": "使用条款",
    "fr": "Conditions d’utilisation",
    "es": "Términos de uso"
  },
  "Premium": {
    "en": "Premium",
    "ta": "பிரீமியம்",
    "si": "ප්‍රිමියම්",
    "hi": "प्रीमियम",
    "ar": "بريميوم",
    "tr": "Premium",
    "ru": "Премиум",
    "zh": "高级会员",
    "fr": "Premium",
    "es": "Prémium"
  },
  "Zugang": {
    "en": "Access",
    "ta": "அணுகல்",
    "si": "ප්‍රවේශය",
    "hi": "पहुँच",
    "ar": "الوصول",
    "tr": "Erişim",
    "ru": "Доступ",
    "zh": "访问权限",
    "fr": "Accès",
    "es": "Acceso"
  },
  "Premium-Zugang": {
    "en": "Premium access",
    "ta": "பிரீமியம் அணுகல்",
    "si": "ප්‍රිමියම් ප්‍රවේශය",
    "hi": "प्रीमियम पहुँच",
    "ar": "الوصول المميز",
    "tr": "Premium erişim",
    "ru": "Премиум-доступ",
    "zh": "高级会员权限",
    "fr": "Accès Premium",
    "es": "Acceso prémium"
  },
  "Anmelden": {
    "en": "Sign in",
    "ta": "உள்நுழைய",
    "si": "පිවිසෙන්න",
    "hi": "साइन इन करें",
    "ar": "تسجيل الدخول",
    "tr": "Giriş yap",
    "ru": "Войти",
    "zh": "登录",
    "fr": "Se connecter",
    "es": "Iniciar sesión"
  },
  "Registrieren": {
    "en": "Register",
    "ta": "பதிவு செய்ய",
    "si": "ලියාපදිංචි වන්න",
    "hi": "पंजीकरण करें",
    "ar": "إنشاء حساب",
    "tr": "Kayıt ol",
    "ru": "Зарегистрироваться",
    "zh": "注册",
    "fr": "S’inscrire",
    "es": "Registrarse"
  },
  "Abmelden": {
    "en": "Sign out",
    "ta": "வெளியேறு",
    "si": "ඉවත් වන්න",
    "hi": "साइन आउट करें",
    "ar": "تسجيل الخروج",
    "tr": "Çıkış yap",
    "ru": "Выйти",
    "zh": "退出登录",
    "fr": "Se déconnecter",
    "es": "Cerrar sesión"
  },
  "Profil": {
    "en": "Profile",
    "ta": "சுயவிவரம்",
    "si": "පැතිකඩ",
    "hi": "प्रोफ़ाइल",
    "ar": "الملف الشخصي",
    "tr": "Profil",
    "ru": "Профиль",
    "zh": "个人资料",
    "fr": "Profil",
    "es": "Perfil"
  },
  "Konto": {
    "en": "Account",
    "ta": "கணக்கு",
    "si": "ගිණුම",
    "hi": "खाता",
    "ar": "الحساب",
    "tr": "Hesap",
    "ru": "Аккаунт",
    "zh": "账户",
    "fr": "Compte",
    "es": "Cuenta"
  },
  "Name": {
    "en": "Name",
    "ta": "பெயர்",
    "si": "නම",
    "hi": "नाम",
    "ar": "الاسم",
    "tr": "Ad",
    "ru": "Имя",
    "zh": "姓名",
    "fr": "Nom",
    "es": "Nombre"
  },
  "E-Mail": {
    "en": "Email",
    "ta": "மின்னஞ்சல்",
    "si": "ඊමේල්",
    "hi": "ईमेल",
    "ar": "البريد الإلكتروني",
    "tr": "E-posta",
    "ru": "Эл. почта",
    "zh": "电子邮箱",
    "fr": "E-mail",
    "es": "Correo electrónico"
  },
  "Telefon": {
    "en": "Phone",
    "ta": "தொலைபேசி",
    "si": "දුරකථනය",
    "hi": "फ़ोन",
    "ar": "الهاتف",
    "tr": "Telefon",
    "ru": "Телефон",
    "zh": "电话",
    "fr": "Téléphone",
    "es": "Teléfono"
  },
  "Hilfe": {
    "en": "Help",
    "ta": "உதவி",
    "si": "උදව්",
    "hi": "सहायता",
    "ar": "المساعدة",
    "tr": "Yardım",
    "ru": "Помощь",
    "zh": "帮助",
    "fr": "Aide",
    "es": "Ayuda"
  },
  "Support": {
    "en": "Support",
    "ta": "ஆதரவு",
    "si": "සහාය",
    "hi": "सहयोग",
    "ar": "الدعم",
    "tr": "Destek",
    "ru": "Поддержка",
    "zh": "支持",
    "fr": "Assistance",
    "es": "Soporte"
  },
  "Dauer": {
    "en": "Duration",
    "ta": "கால அளவு",
    "si": "කාලය",
    "hi": "अवधि",
    "ar": "المدة",
    "tr": "Süre",
    "ru": "Длительность",
    "zh": "时长",
    "fr": "Durée",
    "es": "Duración"
  },
  "Unterricht": {
    "en": "Lessons",
    "ta": "வகுப்புகள்",
    "si": "පාඩම්",
    "hi": "कक्षाएँ",
    "ar": "الدروس",
    "tr": "Dersler",
    "ru": "Занятия",
    "zh": "课时",
    "fr": "Cours",
    "es": "Clases"
  },
  "Kurspreis": {
    "en": "Course price",
    "ta": "பாடநெறிக் கட்டணம்",
    "si": "පාඨමාලා ගාස්තුව",
    "hi": "पाठ्यक्रम शुल्क",
    "ar": "سعر الدورة",
    "tr": "Kurs ücreti",
    "ru": "Стоимость курса",
    "zh": "课程费用",
    "fr": "Prix du cours",
    "es": "Precio del curso"
  },
  "Bücherzugang": {
    "en": "Book access",
    "ta": "புத்தக அணுகல்",
    "si": "පොත් ප්‍රවේශය",
    "hi": "पुस्तकों तक पहुँच",
    "ar": "الوصول إلى الكتب",
    "tr": "Kitap erişimi",
    "ru": "Доступ к книгам",
    "zh": "图书权限",
    "fr": "Accès aux livres",
    "es": "Acceso a libros"
  },
  "Antwortzeit": {
    "en": "Response time",
    "ta": "பதில் அளிக்கும் நேரம்",
    "si": "ප්‍රතිචාර කාලය",
    "hi": "उत्तर देने का समय",
    "ar": "وقت الرد",
    "tr": "Yanıt süresi",
    "ru": "Время ответа",
    "zh": "回复时间",
    "fr": "Délai de réponse",
    "es": "Tiempo de respuesta"
  },
  "Lernangebote": {
    "en": "Learning options",
    "ta": "கற்றல் வாய்ப்புகள்",
    "si": "ඉගෙනුම් අවස්ථා",
    "hi": "सीखने के विकल्प",
    "ar": "خيارات التعلّم",
    "tr": "Öğrenme seçenekleri",
    "ru": "Варианты обучения",
    "zh": "学习内容",
    "fr": "Offres d’apprentissage",
    "es": "Opciones de aprendizaje"
  },
  "Kursniveaus": {
    "en": "Course levels",
    "ta": "பாடநெறி நிலைகள்",
    "si": "පාඨමාලා මට්ටම්",
    "hi": "पाठ्यक्रम के स्तर",
    "ar": "مستويات الدورات",
    "tr": "Kurs seviyeleri",
    "ru": "Уровни курсов",
    "zh": "课程级别",
    "fr": "Niveaux de cours",
    "es": "Niveles de curso"
  },
  "So funktioniert es": {
    "en": "How it works",
    "ta": "இது எவ்வாறு செயல்படுகிறது",
    "si": "එය ක්‍රියා කරන ආකාරය",
    "hi": "यह कैसे काम करता है",
    "ar": "كيف يعمل",
    "tr": "Nasıl çalışır?",
    "ru": "Как это работает",
    "zh": "使用方法",
    "fr": "Comment ça marche",
    "es": "Cómo funciona"
  },
  "Wort des Tages": {
    "en": "Word of the day",
    "ta": "இன்றைய சொல்",
    "si": "දවසේ වචනය",
    "hi": "आज का शब्द",
    "ar": "كلمة اليوم",
    "tr": "Günün kelimesi",
    "ru": "Слово дня",
    "zh": "每日单词",
    "fr": "Mot du jour",
    "es": "Palabra del día"
  },
  "Fragen & Antworten": {
    "en": "Questions & answers",
    "ta": "கேள்விகளும் பதில்களும்",
    "si": "ප්‍රශ්න හා පිළිතුරු",
    "hi": "प्रश्न और उत्तर",
    "ar": "الأسئلة والأجوبة",
    "tr": "Sorular ve cevaplar",
    "ru": "Вопросы и ответы",
    "zh": "常见问答",
    "fr": "Questions et réponses",
    "es": "Preguntas y respuestas"
  },
  "DEAR LANGUAGE · GERMAN A1–C2": {
    "en": "DEAR LANGUAGE · GERMAN A1–C2",
    "ta": "DEAR LANGUAGE · ஜெர்மன் A1–C2",
    "si": "DEAR LANGUAGE · ජර්මන් A1–C2",
    "hi": "DEAR LANGUAGE · जर्मन A1–C2",
    "ar": "DEAR LANGUAGE · الألمانية A1–C2",
    "tr": "DEAR LANGUAGE · ALMANCA A1–C2",
    "ru": "DEAR LANGUAGE · НЕМЕЦКИЙ A1–C2",
    "zh": "DEAR LANGUAGE · 德语 A1–C2",
    "fr": "DEAR LANGUAGE · ALLEMAND A1–C2",
    "es": "DEAR LANGUAGE · ALEMÁN A1–C2"
  },
  "Deutsch lernen. Schritt für Schritt.": {
    "en": "Learn German. Step by step.",
    "ta": "ஜெர்மன் கற்கவும். படிப்படியாக முன்னேறுங்கள்.",
    "si": "ජර්මන් ඉගෙන ගන්න. පියවරෙන් පියවර.",
    "hi": "जर्मन सीखें। कदम दर कदम।",
    "ar": "تعلّم الألمانية. خطوة بخطوة.",
    "tr": "Almanca öğren. Adım adım.",
    "ru": "Учите немецкий. Шаг за шагом.",
    "zh": "学习德语，循序渐进。",
    "fr": "Apprenez l’allemand. Pas à pas.",
    "es": "Aprende alemán. Paso a paso."
  },
  "Deutsch lernen. Wissen vertiefen. Selbstvertrauen entwickeln.": {
    "en": "Learn German. Deepen your knowledge. Build confidence.",
    "ta": "ஜெர்மன் கற்கவும். அறிவை வளர்த்துக்கொள்ளவும். தன்னம்பிக்கையை மேம்படுத்தவும்.",
    "si": "ජර්මන් ඉගෙන ගන්න. දැනුම වැඩි කරන්න. විශ්වාසය ගොඩනගන්න.",
    "hi": "जर्मन सीखें। ज्ञान बढ़ाएँ। आत्मविश्वास विकसित करें।",
    "ar": "تعلّم الألمانية. عمّق معرفتك. عزّز ثقتك بنفسك.",
    "tr": "Almanca öğren. Bilgini geliştir. Özgüven kazan.",
    "ru": "Изучайте немецкий. Углубляйте знания. Развивайте уверенность.",
    "zh": "学习德语。深化知识。建立信心。",
    "fr": "Apprenez l’allemand. Approfondissez vos connaissances. Gagnez en confiance.",
    "es": "Aprende alemán. Amplía tus conocimientos. Gana confianza."
  },
  "Kursangebot entdecken": {
    "en": "Explore courses",
    "ta": "பாடநெறிகளைப் பார்க்க",
    "si": "පාඨමාලා බලන්න",
    "hi": "पाठ्यक्रम देखें",
    "ar": "استكشف الدورات",
    "tr": "Kursları keşfet",
    "ru": "Смотреть курсы",
    "zh": "探索课程",
    "fr": "Découvrir les cours",
    "es": "Explorar cursos"
  },
  "Bücherbibliothek öffnen": {
    "en": "Open book library",
    "ta": "புத்தக நூலகத்தைத் திறக்க",
    "si": "පොත් පුස්තකාලය විවෘත කරන්න",
    "hi": "पुस्तकालय खोलें",
    "ar": "افتح مكتبة الكتب",
    "tr": "Kitap kütüphanesini aç",
    "ru": "Открыть библиотеку",
    "zh": "打开图书馆",
    "fr": "Ouvrir la bibliothèque",
    "es": "Abrir biblioteca"
  },
  "DEIN LERNANGEBOT": {
    "en": "YOUR LEARNING OPTIONS",
    "ta": "உங்களுக்கான கற்றல் வாய்ப்புகள்",
    "si": "ඔබේ ඉගෙනුම් අවස්ථා",
    "hi": "आपके सीखने के विकल्प",
    "ar": "خيارات التعلّم المتاحة لك",
    "tr": "ÖĞRENME SEÇENEKLERİN",
    "ru": "ВАШИ ВОЗМОЖНОСТИ",
    "zh": "您的学习内容",
    "fr": "VOTRE OFFRE D’APPRENTISSAGE",
    "es": "TU OFERTA DE APRENDIZAJE"
  },
  "Online-Kurse von A1 bis B2": {
    "en": "Online courses from A1 to B2",
    "ta": "A1 முதல் B2 வரையிலான இணையவழிப் பாடநெறிகள்",
    "si": "A1 සිට B2 දක්වා මාර්ගගත පාඨමාලා",
    "hi": "A1 से B2 तक ऑनलाइन पाठ्यक्रम",
    "ar": "دورات عبر الإنترنت من A1 إلى B2",
    "tr": "A1'den B2'ye çevrim içi kurslar",
    "ru": "Онлайн-курсы от A1 до B2",
    "zh": "A1 至 B2 在线课程",
    "fr": "Cours en ligne de A1 à B2",
    "es": "Cursos en línea de A1 a B2"
  },
  "Bücher für A1 bis C2": {
    "en": "Books from A1 to C2",
    "ta": "A1 முதல் C2 வரையிலான புத்தகங்கள்",
    "si": "A1 සිට C2 දක්වා පොත්",
    "hi": "A1 से C2 तक पुस्तकें",
    "ar": "كتب من A1 إلى C2",
    "tr": "A1'den C2'ye kitaplar",
    "ru": "Книги от A1 до C2",
    "zh": "A1 至 C2 图书",
    "fr": "Livres de A1 à C2",
    "es": "Libros de A1 a C2"
  },
  "Unterstützte Übersetzungssprachen": {
    "en": "Supported translation languages",
    "ta": "ஆதரிக்கப்படும் மொழிபெயர்ப்பு மொழிகள்",
    "si": "සහාය දක්වන පරිවර්තන භාෂා",
    "hi": "समर्थित अनुवाद भाषाएँ",
    "ar": "لغات الترجمة المدعومة",
    "tr": "Desteklenen çeviri dilleri",
    "ru": "Поддерживаемые языки перевода",
    "zh": "支持的翻译语言",
    "fr": "Langues de traduction prises en charge",
    "es": "Idiomas de traducción disponibles"
  },
  "Mit Website und mobiler App lernen": {
    "en": "Learn on the website and mobile app",
    "ta": "இணையதளத்திலும் மொபைல் செயலியிலும் கற்கலாம்",
    "si": "වෙබ් අඩවියෙන් සහ ජංගම යෙදුමෙන් ඉගෙන ගන්න",
    "hi": "वेबसाइट और मोबाइल ऐप से सीखें",
    "ar": "تعلّم عبر الموقع وتطبيق الهاتف",
    "tr": "Web sitesi ve mobil uygulamayla öğren",
    "ru": "Учитесь на сайте и в приложении",
    "zh": "通过网站和移动应用学习",
    "fr": "Apprenez sur le site et l’application",
    "es": "Aprende en la web y la aplicación"
  },
  "LERNEN MIT DEAR LANGUAGE": {
    "en": "LEARN WITH DEAR LANGUAGE",
    "ta": "DEAR LANGUAGE உடன் கற்கவும்",
    "si": "DEAR LANGUAGE සමඟ ඉගෙන ගන්න",
    "hi": "DEAR LANGUAGE के साथ सीखें",
    "ar": "تعلّم مع DEAR LANGUAGE",
    "tr": "DEAR LANGUAGE İLE ÖĞREN",
    "ru": "УЧИТЕСЬ С DEAR LANGUAGE",
    "zh": "与 DEAR LANGUAGE 一起学习",
    "fr": "APPRENEZ AVEC DEAR LANGUAGE",
    "es": "APRENDE CON DEAR LANGUAGE"
  },
  "Unsere Lernangebote im Überblick": {
    "en": "Our learning options at a glance",
    "ta": "எங்கள் கற்றல் வாய்ப்புகள் ஒரு பார்வையில்",
    "si": "අපගේ ඉගෙනුම් අවස්ථා කෙටියෙන්",
    "hi": "हमारे सीखने के विकल्प एक नज़र में",
    "ar": "نظرة عامة على خيارات التعلّم",
    "tr": "Öğrenme seçeneklerimize genel bakış",
    "ru": "Наши варианты обучения",
    "zh": "学习内容一览",
    "fr": "Nos offres d’apprentissage en bref",
    "es": "Nuestras opciones de aprendizaje"
  },
  "01 · UNTERRICHT": {
    "en": "01 · CLASSES",
    "ta": "01 · வகுப்புகள்",
    "si": "01 · පන්ති",
    "hi": "01 · कक्षाएँ",
    "ar": "01 · الدروس",
    "tr": "01 · DERSLER",
    "ru": "01 · ЗАНЯТИЯ",
    "zh": "01 · 课程",
    "fr": "01 · COURS",
    "es": "01 · CLASES"
  },
  "Deutschkurse": {
    "en": "German courses",
    "ta": "ஜெர்மன் பாடநெறிகள்",
    "si": "ජර්මන් පාඨමාලා",
    "hi": "जर्मन पाठ्यक्रम",
    "ar": "دورات اللغة الألمانية",
    "tr": "Almanca kursları",
    "ru": "Курсы немецкого",
    "zh": "德语课程",
    "fr": "Cours d’allemand",
    "es": "Cursos de alemán"
  },
  "02 · LESETRAINING": {
    "en": "02 · READING PRACTICE",
    "ta": "02 · வாசிப்புப் பயிற்சி",
    "si": "02 · කියවීමේ පුහුණුව",
    "hi": "02 · पढ़ने का अभ्यास",
    "ar": "02 · تدريب القراءة",
    "tr": "02 · OKUMA ALIŞTIRMALARI",
    "ru": "02 · ЧТЕНИЕ",
    "zh": "02 · 阅读练习",
    "fr": "02 · ENTRAÎNEMENT À LA LECTURE",
    "es": "02 · PRÁCTICA DE LECTURA"
  },
  "Deutschbücher": {
    "en": "German books",
    "ta": "ஜெர்மன் புத்தகங்கள்",
    "si": "ජර්මන් පොත්",
    "hi": "जर्मन पुस्तकें",
    "ar": "كتب اللغة الألمانية",
    "tr": "Almanca kitaplar",
    "ru": "Книги по немецкому",
    "zh": "德语图书",
    "fr": "Livres d’allemand",
    "es": "Libros de alemán"
  },
  "03 · TÄGLICH ÜBEN": {
    "en": "03 · DAILY PRACTICE",
    "ta": "03 · தினசரிப் பயிற்சி",
    "si": "03 · දිනපතා පුහුණුව",
    "hi": "03 · दैनिक अभ्यास",
    "ar": "03 · التدريب اليومي",
    "tr": "03 · GÜNLÜK ALIŞTIRMA",
    "ru": "03 · ЕЖЕДНЕВНАЯ ПРАКТИКА",
    "zh": "03 · 每日练习",
    "fr": "03 · PRATIQUE QUOTIDIENNE",
    "es": "03 · PRÁCTICA DIARIA"
  },
  "Zum Kursangebot": {
    "en": "View courses",
    "ta": "பாடநெறிகளைப் பார்க்க",
    "si": "පාඨමාලා වෙත",
    "hi": "पाठ्यक्रम देखें",
    "ar": "عرض الدورات",
    "tr": "Kurslara git",
    "ru": "К курсам",
    "zh": "查看课程",
    "fr": "Voir les cours",
    "es": "Ver cursos"
  },
  "Zur Bibliothek": {
    "en": "Go to library",
    "ta": "நூலகத்திற்குச் செல்ல",
    "si": "පුස්තකාලය වෙත",
    "hi": "पुस्तकालय जाएँ",
    "ar": "الانتقال إلى المكتبة",
    "tr": "Kütüphaneye git",
    "ru": "В библиотеку",
    "zh": "前往图书馆",
    "fr": "Voir la bibliothèque",
    "es": "Ir a la biblioteca"
  },
  "Heutiges Wort entdecken": {
    "en": "Discover today's word",
    "ta": "இன்றைய சொல்லைக் காண",
    "si": "අද වචනය බලන්න",
    "hi": "आज का शब्द देखें",
    "ar": "اكتشف كلمة اليوم",
    "tr": "Günün kelimesini keşfet",
    "ru": "Узнать слово дня",
    "zh": "查看今日单词",
    "fr": "Découvrir le mot du jour",
    "es": "Descubrir la palabra de hoy"
  },
  "Von den ersten deutschen Wörtern bis zu anspruchsvollen Texten: entdecke strukturierte Kurse, eine nach Niveaus gegliederte Bücherbibliothek und tägliche Sprachimpulse.": {
    "en": "From your first German words to advanced texts: discover structured courses, a level-based book library, and daily language inspiration.",
    "ta": "முதல் ஜெர்மன் சொற்களிலிருந்து உயர்நிலை உரைகள் வரை: ஒழுங்கமைக்கப்பட்ட பாடநெறிகள், நிலைவாரியாகப் பிரிக்கப்பட்ட புத்தக நூலகம் மற்றும் தினசரி மொழிப் பயிற்சிகளை அறிந்துகொள்ளுங்கள்.",
    "si": "පළමු ජර්මන් වචනවල සිට උසස් පෙළ දක්වා: සංවිධානාත්මක පාඨමාලා, මට්ටම් අනුව පොත් සහ දිනපතා භාෂා පුහුණුව සොයාගන්න.",
    "hi": "पहले जर्मन शब्दों से लेकर उन्नत पाठों तक: व्यवस्थित पाठ्यक्रम, स्तरवार पुस्तकालय और दैनिक भाषा अभ्यास खोजें।",
    "ar": "من أولى الكلمات الألمانية إلى النصوص المتقدمة: اكتشف الدورات المنظمة ومكتبة الكتب بحسب المستوى والتدريب اللغوي اليومي.",
    "tr": "İlk Almanca kelimelerden ileri düzey metinlere: düzenli kursları, seviyelere göre kitap kütüphanesini ve günlük dil alıştırmalarını keşfet.",
    "ru": "От первых немецких слов до сложных текстов: откройте структурированные курсы, библиотеку по уровням и ежедневную языковую практику.",
    "zh": "从第一个德语单词到高级文章：探索系统课程、分级图书馆和每日语言练习。",
    "fr": "Des premiers mots allemands aux textes avancés : découvrez des cours structurés, une bibliothèque par niveau et des activités quotidiennes.",
    "es": "Desde las primeras palabras en alemán hasta textos avanzados: descubre cursos estructurados, una biblioteca por niveles y práctica diaria."
  },
  "Wähle das passende Lernformat für dein Ziel und deinen Alltag.": {
    "en": "Choose the learning format that fits your goals and everyday life.",
    "ta": "உங்கள் இலக்கிற்கும் அன்றாட வாழ்க்கைக்கும் ஏற்ற கற்றல் முறையைத் தேர்ந்தெடுக்கவும்.",
    "si": "ඔබේ අරමුණු හා දෛනික ජීවිතයට ගැළපෙන ඉගෙනුම් ක්‍රමය තෝරන්න.",
    "hi": "अपने लक्ष्य और दिनचर्या के अनुरूप सीखने का तरीका चुनें।",
    "ar": "اختر طريقة التعلّم التي تناسب أهدافك وحياتك اليومية.",
    "tr": "Hedefine ve günlük yaşamına uygun öğrenme yöntemini seç.",
    "ru": "Выберите формат обучения под свои цели и распорядок дня.",
    "zh": "选择适合您的目标和日常生活的学习方式。",
    "fr": "Choisissez le format d’apprentissage adapté à vos objectifs et à votre quotidien.",
    "es": "Elige el formato de aprendizaje que mejor se adapte a tus objetivos y rutina."
  },
  "Kursinformationen, Lernstufen, Dauer und Unterrichtsumfang auf einen Blick.": {
    "en": "Course information, levels, duration, and lesson hours at a glance.",
    "ta": "பாடநெறி விவரங்கள், நிலைகள், கால அளவு, வகுப்பு நேரம் ஆகியவற்றை ஒரே பார்வையில் காணுங்கள்.",
    "si": "පාඨමාලා තොරතුරු, මට්ටම්, කාලය සහ පන්ති වේලාවන් එකවර බලන්න.",
    "hi": "पाठ्यक्रम की जानकारी, स्तर, अवधि और कक्षा घंटे एक नज़र में।",
    "ar": "معلومات الدورات والمستويات والمدة وساعات التدريس بنظرة واحدة.",
    "tr": "Kurs bilgileri, seviyeler, süre ve ders saatleri bir bakışta.",
    "ru": "Информация о курсах, уровнях, длительности и часах занятий.",
    "zh": "一目了然地查看课程信息、级别、时长和课时。",
    "fr": "Informations sur les cours, niveaux, durée et heures d’enseignement en un coup d’œil.",
    "es": "Información del curso, niveles, duración y horas de clase de un vistazo."
  },
  "60 Bücher, geordnet nach den sechs Kompetenzstufen A1 bis C2.": {
    "en": "60 books organized into the six levels from A1 to C2.",
    "ta": "A1 முதல் C2 வரையிலான ஆறு நிலைகளில் ஒழுங்கமைக்கப்பட்ட 60 புத்தகங்கள்.",
    "si": "A1 සිට C2 දක්වා මට්ටම් හයකට වෙන් කළ පොත් 60ක්.",
    "hi": "A1 से C2 के छह स्तरों में व्यवस्थित 60 पुस्तकें।",
    "ar": "60 كتابًا موزعة على ستة مستويات من A1 إلى C2.",
    "tr": "A1'den C2'ye altı seviyeye ayrılmış 60 kitap.",
    "ru": "60 книг по шести уровням от A1 до C2.",
    "zh": "从 A1 到 C2 六个级别的 60 本书。",
    "fr": "60 livres répartis en six niveaux de A1 à C2.",
    "es": "60 libros organizados en seis niveles de A1 a C2."
  },
  "Deutsche Wörter und Beispielsätze mit Übersetzung in deiner gewählten Sprache.": {
    "en": "German words and example sentences translated into your chosen language.",
    "ta": "நீங்கள் தேர்ந்தெடுத்த மொழியில் மொழிபெயர்ப்புடன் ஜெர்மன் சொற்களும் எடுத்துக்காட்டு வாக்கியங்களும்.",
    "si": "ඔබ තෝරාගත් භාෂාවේ පරිවර්තන සමඟ ජර්මන් වචන හා උදාහරණ වාක්‍ය.",
    "hi": "आपकी चुनी हुई भाषा में अनुवाद के साथ जर्मन शब्द और उदाहरण वाक्य।",
    "ar": "كلمات وجمل ألمانية مع ترجمتها إلى اللغة التي تختارها.",
    "tr": "Seçtiğin dile çevrilmiş Almanca kelimeler ve örnek cümleler.",
    "ru": "Немецкие слова и примеры с переводом на выбранный язык.",
    "zh": "提供您所选语言译文的德语单词和例句。",
    "fr": "Mots et phrases d’exemple allemands traduits dans la langue choisie.",
    "es": "Palabras y frases de ejemplo en alemán con traducción al idioma elegido."
  },
  "Deutschkurse nach Lernniveau": {
    "en": "German courses by level",
    "ta": "நிலைவாரியான ஜெர்மன் பாடநெறிகள்",
    "si": "මට්ටම් අනුව ජර්මන් පාඨමාලා",
    "hi": "स्तर के अनुसार जर्मन पाठ्यक्रम",
    "ar": "دورات الألمانية حسب المستوى",
    "tr": "Seviyeye göre Almanca kursları",
    "ru": "Курсы немецкого по уровням",
    "zh": "按级别划分的德语课程",
    "fr": "Cours d’allemand par niveau",
    "es": "Cursos de alemán por nivel"
  },
  "Vergleiche die Kursstufen und öffne die vollständigen Kursdetails.": {
    "en": "Compare levels and open the full course details.",
    "ta": "நிலைகளை ஒப்பிட்டு முழுப் பாடநெறி விவரங்களைப் பார்க்கவும்.",
    "si": "මට්ටම් සසඳා සම්පූර්ණ පාඨමාලා විස්තර බලන්න.",
    "hi": "स्तरों की तुलना करें और पाठ्यक्रम का पूरा विवरण देखें।",
    "ar": "قارن المستويات وافتح التفاصيل الكاملة لكل دورة.",
    "tr": "Seviyeleri karşılaştır ve tüm kurs ayrıntılarını aç.",
    "ru": "Сравните уровни и откройте подробности курса.",
    "zh": "比较各级别并查看完整课程详情。",
    "fr": "Comparez les niveaux et consultez les détails complets des cours.",
    "es": "Compara los niveles y consulta todos los detalles del curso."
  },
  "Details ansehen": {
    "en": "View details",
    "ta": "விவரங்களைப் பார்க்க",
    "si": "විස්තර බලන්න",
    "hi": "विवरण देखें",
    "ar": "عرض التفاصيل",
    "tr": "Ayrıntıları gör",
    "ru": "Подробнее",
    "zh": "查看详情",
    "fr": "Voir les détails",
    "es": "Ver detalles"
  },
  "DEUTSCHBIBLIOTHEK": {
    "en": "GERMAN LIBRARY",
    "ta": "ஜெர்மன் புத்தக நூலகம்",
    "si": "ජර්මන් පුස්තකාලය",
    "hi": "जर्मन पुस्तकालय",
    "ar": "مكتبة الكتب الألمانية",
    "tr": "ALMANCA KÜTÜPHANESİ",
    "ru": "БИБЛИОТЕКА НЕМЕЦКОГО",
    "zh": "德语图书馆",
    "fr": "BIBLIOTHÈQUE ALLEMANDE",
    "es": "BIBLIOTECA DE ALEMÁN"
  },
  "Lesen auf deinem Niveau": {
    "en": "Read at your level",
    "ta": "உங்கள் நிலைக்கு ஏற்றவாறு வாசிக்கவும்",
    "si": "ඔබේ මට්ටමට කියවන්න",
    "hi": "अपने स्तर पर पढ़ें",
    "ar": "اقرأ وفق مستواك",
    "tr": "Seviyene uygun oku",
    "ru": "Читайте на своём уровне",
    "zh": "按您的级别阅读",
    "fr": "Lisez à votre niveau",
    "es": "Lee a tu nivel"
  },
  "Die Bibliothek umfasst 60 Bücher. Finde deine Niveaustufe und nutze die Titel, für die du bereits Zugang hast.": {
    "en": "The library contains 60 books. Find your level and use the titles you can access.",
    "ta": "இந்த நூலகத்தில் 60 புத்தகங்கள் உள்ளன. உங்கள் நிலையைக் கண்டறிந்து, அணுகல் உள்ள புத்தகங்களைப் பயன்படுத்துங்கள்.",
    "si": "පුස්තකාලයේ පොත් 60ක් ඇත. ඔබේ මට්ටම සොයා ඔබට ප්‍රවේශ ඇති පොත් භාවිත කරන්න.",
    "hi": "पुस्तकालय में 60 पुस्तकें हैं। अपना स्तर चुनें और उपलब्ध पुस्तकों का उपयोग करें।",
    "ar": "تضم المكتبة 60 كتابًا. اختر مستواك واستخدم الكتب المتاحة لك.",
    "tr": "Kütüphanede 60 kitap var. Seviyeni bul ve erişebildiğin kitapları kullan.",
    "ru": "В библиотеке 60 книг. Найдите свой уровень и используйте доступные книги.",
    "zh": "图书馆共有 60 本书。找到适合的级别，使用您有权限的图书。",
    "fr": "La bibliothèque comprend 60 livres. Trouvez votre niveau et utilisez les titres accessibles.",
    "es": "La biblioteca tiene 60 libros. Encuentra tu nivel y usa los títulos a los que tienes acceso."
  },
  "Bücher öffnen": {
    "en": "Open books",
    "ta": "புத்தகங்களைத் திறக்க",
    "si": "පොත් විවෘත කරන්න",
    "hi": "पुस्तकें खोलें",
    "ar": "فتح الكتب",
    "tr": "Kitapları aç",
    "ru": "Открыть книги",
    "zh": "打开图书",
    "fr": "Ouvrir les livres",
    "es": "Abrir libros"
  },
  "Freischaltungen werden über dein bestehendes Konto geprüft.": {
    "en": "Access is checked through your existing account.",
    "ta": "உங்கள் கணக்கின் மூலம் அணுகல் அனுமதி சரிபார்க்கப்படும்.",
    "si": "ඔබේ ගිණුමෙන් ප්‍රවේශය පරීක්ෂා කෙරේ.",
    "hi": "आपके मौजूदा खाते से पहुँच की जाँच की जाती है।",
    "ar": "يتم التحقق من الوصول عبر حسابك الحالي.",
    "tr": "Erişimin mevcut hesabınla kontrol edilir.",
    "ru": "Доступ проверяется через ваш аккаунт.",
    "zh": "通过现有账户核验访问权限。",
    "fr": "L’accès est vérifié via votre compte existant.",
    "es": "Se comprueba el acceso mediante tu cuenta actual."
  },
  "10 Bücher": {
    "en": "10 books",
    "ta": "10 புத்தகங்கள்",
    "si": "පොත් 10ක්",
    "hi": "10 पुस्तकें",
    "ar": "10 كتب",
    "tr": "10 kitap",
    "ru": "10 книг",
    "zh": "10 本书",
    "fr": "10 livres",
    "es": "10 libros"
  },
  "ORIENTIERUNG": {
    "en": "GETTING STARTED",
    "ta": "வழிகாட்டுதல்",
    "si": "මඟපෙන්වීම",
    "hi": "मार्गदर्शन",
    "ar": "إرشادات",
    "tr": "REHBERLİK",
    "ru": "С ЧЕГО НАЧАТЬ",
    "zh": "学习指南",
    "fr": "ORIENTATION",
    "es": "ORIENTACIÓN"
  },
  "Dein Weg zum passenden Lernangebot": {
    "en": "Your path to the right learning option",
    "ta": "உங்களுக்கேற்ற கற்றல் முறைக்கான வழி",
    "si": "සුදුසු ඉගෙනුම් ක්‍රමයට ඔබේ මඟ",
    "hi": "सही सीखने के विकल्प की राह",
    "ar": "طريقك إلى الخيار المناسب",
    "tr": "Sana uygun öğrenme yolunu bul",
    "ru": "Путь к подходящему обучению",
    "zh": "寻找适合您的学习方式",
    "fr": "Votre parcours vers la bonne offre",
    "es": "Tu camino hacia la formación adecuada"
  },
  "DEUTSCH IM ALLTAG": {
    "en": "GERMAN IN DAILY LIFE",
    "ta": "அன்றாட வாழ்க்கையில் ஜெர்மன்",
    "si": "දෛනික ජීවිතයේ ජර්මන්",
    "hi": "दैनिक जीवन में जर्मन",
    "ar": "الألمانية في الحياة اليومية",
    "tr": "GÜNLÜK YAŞAMDA ALMANCA",
    "ru": "НЕМЕЦКИЙ В ПОВСЕДНЕВНОЙ ЖИЗНИ",
    "zh": "日常德语",
    "fr": "L’ALLEMAND AU QUOTIDIEN",
    "es": "ALEMÁN COTIDIANO"
  },
  "Ein neues Wort. Ein neuer Satz.": {
    "en": "A new word. A new sentence.",
    "ta": "ஒரு புதிய சொல். ஒரு புதிய வாக்கியம்.",
    "si": "අලුත් වචනයක්. අලුත් වාක්‍යයක්.",
    "hi": "एक नया शब्द। एक नया वाक्य।",
    "ar": "كلمة جديدة. جملة جديدة.",
    "tr": "Yeni bir kelime. Yeni bir cümle.",
    "ru": "Новое слово. Новое предложение.",
    "zh": "一个新单词。一句新句子。",
    "fr": "Un nouveau mot. Une nouvelle phrase.",
    "es": "Una palabra nueva. Una frase nueva."
  },
  "Entdecke das heutige Wort auf Deutsch und in deiner gewählten Übersetzungssprache. Tippe auf den Text, um ihn anzuhören.": {
    "en": "Discover today's word in German and your chosen translation language. Tap the text to hear it.",
    "ta": "இன்றைய ஜெர்மன் சொல்லையும் நீங்கள் தேர்ந்தெடுத்த மொழியில் அதன் மொழிபெயர்ப்பையும் அறிந்துகொள்ளுங்கள். ஒலியைக் கேட்க உரையைத் தட்டவும்.",
    "si": "අද ජර්මන් වචනය හා තෝරාගත් භාෂාවේ පරිවර්තනය බලන්න. ඇසීමට පෙළ තට්ටු කරන්න.",
    "hi": "आज का जर्मन शब्द और चुनी भाषा में उसका अनुवाद देखें। सुनने के लिए पाठ पर टैप करें।",
    "ar": "تعرّف إلى كلمة اليوم بالألمانية وترجمتها بلغتك المختارة. اضغط على النص لسماعه.",
    "tr": "Bugünün Almanca kelimesini ve seçtiğin dildeki çevirisini keşfet. Dinlemek için metne dokun.",
    "ru": "Узнайте слово дня на немецком и его перевод. Нажмите на текст, чтобы услышать произношение.",
    "zh": "探索今天的德语单词及所选语言译文。点击文字可收听发音。",
    "fr": "Découvrez le mot du jour en allemand et sa traduction. Touchez le texte pour l’écouter.",
    "es": "Descubre la palabra del día en alemán y su traducción. Toca el texto para escucharla."
  },
  "Deutsche Beispielsätze": {
    "en": "German example sentences",
    "ta": "ஜெர்மன் எடுத்துக்காட்டு வாக்கியங்கள்",
    "si": "ජර්මන් උදාහරණ වාක්‍ය",
    "hi": "जर्मन उदाहरण वाक्य",
    "ar": "جمل ألمانية توضيحية",
    "tr": "Almanca örnek cümleler",
    "ru": "Немецкие примеры предложений",
    "zh": "德语例句",
    "fr": "Phrases d’exemple en allemand",
    "es": "Frases de ejemplo en alemán"
  },
  "Übersetzungen": {
    "en": "Translations",
    "ta": "மொழிபெயர்ப்புகள்",
    "si": "පරිවර්තන",
    "hi": "अनुवाद",
    "ar": "الترجمات",
    "tr": "Çeviriler",
    "ru": "Переводы",
    "zh": "译文",
    "fr": "Traductions",
    "es": "Traducciones"
  },
  "Aussprache per Klick": {
    "en": "Tap to hear pronunciation",
    "ta": "உச்சரிப்பைக் கேட்கத் தட்டவும்",
    "si": "උච්චාරණය ඇසීමට තට්ටු කරන්න",
    "hi": "उच्चारण सुनने के लिए टैप करें",
    "ar": "اضغط لسماع النطق",
    "tr": "Telaffuzu dinlemek için dokun",
    "ru": "Нажмите для прослушивания",
    "zh": "点击收听发音",
    "fr": "Touchez pour écouter la prononciation",
    "es": "Toca para oír la pronunciación"
  },
  "LERNEN, DAS ZU DEINEM ALLTAG PASST": {
    "en": "LEARNING FOR EVERYDAY LIFE",
    "ta": "உங்கள் அன்றாட வாழ்க்கைக்கேற்ற கற்றல்",
    "si": "දෛනික ජීවිතයට ගැළපෙන ඉගෙනීම",
    "hi": "रोज़मर्रा के लिए उपयुक्त शिक्षा",
    "ar": "تعلّم يناسب حياتك اليومية",
    "tr": "GÜNLÜK HAYATINA UYGUN ÖĞRENME",
    "ru": "УЧЁБА ДЛЯ ПОВСЕДНЕВНОЙ ЖИЗНИ",
    "zh": "适合日常生活的学习方式",
    "fr": "APPRENDRE SELON VOTRE QUOTIDIEN",
    "es": "APRENDIZAJE PARA TU DÍA A DÍA"
  },
  "Drei Wege, deine Deutschkenntnisse zu vertiefen": {
    "en": "Three ways to improve your German",
    "ta": "உங்கள் ஜெர்மன் திறனை வளர்க்க மூன்று வழிகள்",
    "si": "ජර්මන් දැනුම දියුණු කිරීමට ක්‍රම තුනක්",
    "hi": "जर्मन बेहतर करने के तीन तरीके",
    "ar": "ثلاث طرق لتعزيز مهاراتك في الألمانية",
    "tr": "Almancanı geliştirmenin üç yolu",
    "ru": "Три способа улучшить немецкий",
    "zh": "提升德语能力的三种方式",
    "fr": "Trois façons d’améliorer votre allemand",
    "es": "Tres formas de mejorar tu alemán"
  },
  "Strukturiert lernen": {
    "en": "Structured learning",
    "ta": "முறையாகக் கற்கவும்",
    "si": "ව්‍යුහගත ඉගෙනීම",
    "hi": "व्यवस्थित तरीके से सीखें",
    "ar": "تعلّم منظّم",
    "tr": "Planlı öğren",
    "ru": "Учитесь системно",
    "zh": "系统学习",
    "fr": "Apprendre de façon structurée",
    "es": "Aprende de forma estructurada"
  },
  "Mit Kursstufen und verständlichen Informationen zum passenden Unterricht.": {
    "en": "Course levels and clear information about suitable lessons.",
    "ta": "பாடநெறி நிலைகள் மற்றும் பொருத்தமான வகுப்புகள் குறித்த தெளிவான தகவல்கள்.",
    "si": "පාඨමාලා මට්ටම් සහ සුදුසු පන්ති පිළිබඳ පැහැදිලි තොරතුරු.",
    "hi": "पाठ्यक्रम स्तर और उपयुक्त कक्षाओं की स्पष्ट जानकारी।",
    "ar": "مستويات الدورات ومعلومات واضحة حول الدروس المناسبة.",
    "tr": "Kurs seviyeleri ve uygun dersler hakkında açık bilgiler.",
    "ru": "Уровни курсов и понятная информация о занятиях.",
    "zh": "查看课程级别和适合课程的清晰信息。",
    "fr": "Des niveaux de cours et des informations claires sur les leçons adaptées.",
    "es": "Niveles e información clara sobre las clases adecuadas."
  },
  "Regelmäßig lesen": {
    "en": "Read regularly",
    "ta": "தொடர்ந்து வாசிக்கவும்",
    "si": "නිතර කියවන්න",
    "hi": "नियमित रूप से पढ़ें",
    "ar": "اقرأ بانتظام",
    "tr": "Düzenli oku",
    "ru": "Читайте регулярно",
    "zh": "定期阅读",
    "fr": "Lire régulièrement",
    "es": "Lee con regularidad"
  },
  "Nutze die Bücher nach Niveaustufe, um dein Lesen Schritt für Schritt zu trainieren.": {
    "en": "Use level-based books to improve your reading step by step.",
    "ta": "நிலைவாரியான புத்தகங்களைக் கொண்டு படிப்படியாக வாசிப்புத் திறனை மேம்படுத்துங்கள்.",
    "si": "මට්ටම් අනුව පොත් භාවිත කර කියවීම ක්‍රමයෙන් දියුණු කරන්න.",
    "hi": "स्तरवार पुस्तकों से धीरे-धीरे पढ़ने की क्षमता बढ़ाएँ।",
    "ar": "استخدم الكتب حسب المستوى لتحسين القراءة خطوة بخطوة.",
    "tr": "Seviyeye göre kitaplarla okumanı adım adım geliştir.",
    "ru": "Постепенно развивайте чтение с книгами по уровням.",
    "zh": "通过分级图书逐步提高阅读能力。",
    "fr": "Améliorez votre lecture progressivement avec des livres par niveau.",
    "es": "Mejora tu lectura paso a paso con libros por niveles."
  },
  "Auch mobil üben": {
    "en": "Practise on mobile",
    "ta": "மொபைலிலும் பயிற்சி செய்யவும்",
    "si": "ජංගම දුරකථනයෙන් පුහුණු වන්න",
    "hi": "मोबाइल पर अभ्यास करें",
    "ar": "تدرّب على الهاتف",
    "tr": "Mobilde de çalış",
    "ru": "Занимайтесь на телефоне",
    "zh": "移动端练习",
    "fr": "S’entraîner sur mobile",
    "es": "Practica en el móvil"
  },
  "Öffne die DEAR LANGUAGE App unterwegs auf deinem iPhone oder Android-Gerät.": {
    "en": "Use the DEAR LANGUAGE app on your iPhone or Android device.",
    "ta": "உங்கள் iPhone அல்லது Android சாதனத்தில் DEAR LANGUAGE செயலியைப் பயன்படுத்துங்கள்.",
    "si": "iPhone හෝ Android මත DEAR LANGUAGE යෙදුම භාවිත කරන්න.",
    "hi": "iPhone या Android पर DEAR LANGUAGE ऐप का उपयोग करें।",
    "ar": "استخدم تطبيق DEAR LANGUAGE على iPhone أو Android.",
    "tr": "DEAR LANGUAGE uygulamasını iPhone veya Android cihazında kullan.",
    "ru": "Используйте приложение DEAR LANGUAGE на iPhone или Android.",
    "zh": "在 iPhone 或 Android 上使用 DEAR LANGUAGE 应用。",
    "fr": "Utilisez l’application DEAR LANGUAGE sur iPhone ou Android.",
    "es": "Usa DEAR LANGUAGE en tu iPhone o Android."
  },
  "ÜBER DEAR LANGUAGE": {
    "en": "ABOUT DEAR LANGUAGE",
    "ta": "DEAR LANGUAGE பற்றி",
    "si": "DEAR LANGUAGE ගැන",
    "hi": "DEAR LANGUAGE के बारे में",
    "ar": "عن DEAR LANGUAGE",
    "tr": "DEAR LANGUAGE HAKKINDA",
    "ru": "О DEAR LANGUAGE",
    "zh": "关于 DEAR LANGUAGE",
    "fr": "À PROPOS DE DEAR LANGUAGE",
    "es": "SOBRE DEAR LANGUAGE"
  },
  "Menschen hinter dem Lernangebot": {
    "en": "The people behind the learning platform",
    "ta": "கற்றல் தளத்தின் பின்னணியில் உள்ளவர்கள்",
    "si": "ඉගෙනුම් වේදිකාව පිටුපස සිටින අය",
    "hi": "हमारे मंच के पीछे की टीम",
    "ar": "الأشخاص وراء منصة التعلّم",
    "tr": "Öğrenme platformunun arkasındaki ekip",
    "ru": "Команда обучающей платформы",
    "zh": "学习平台背后的团队",
    "fr": "Les personnes derrière la plateforme",
    "es": "El equipo detrás de la plataforma"
  },
  "Entwicklung, Organisation und inhaltliche Betreuung an einem Ort.": {
    "en": "Development, organization, and content support in one place.",
    "ta": "உருவாக்கம், நிர்வாகம், உள்ளடக்க உதவி என அனைத்தும் ஒரே இடத்தில்.",
    "si": "සංවර්ධනය, සංවිධානය සහ අන්තර්ගත සහාය එක තැනක.",
    "hi": "विकास, प्रबंधन और सामग्री सहायता एक ही स्थान पर।",
    "ar": "التطوير والتنظيم ودعم المحتوى في مكان واحد.",
    "tr": "Geliştirme, organizasyon ve içerik desteği bir arada.",
    "ru": "Разработка, организация и поддержка материалов в одном месте.",
    "zh": "开发、运营和内容支持一站完成。",
    "fr": "Développement, organisation et accompagnement des contenus réunis.",
    "es": "Desarrollo, organización y apoyo de contenidos en un solo lugar."
  },
  "GRÜNDUNG & ENTWICKLUNG": {
    "en": "FOUNDER & DEVELOPMENT",
    "ta": "நிறுவல் மற்றும் உருவாக்கம்",
    "si": "ආරම්භය සහ සංවර්ධනය",
    "hi": "संस्थापना और विकास",
    "ar": "التأسيس والتطوير",
    "tr": "KURULUŞ VE GELİŞTİRME",
    "ru": "СОЗДАНИЕ И РАЗРАБОТКА",
    "zh": "创办与开发",
    "fr": "FONDATION ET DÉVELOPPEMENT",
    "es": "FUNDACIÓN Y DESARROLLO"
  },
  "Gründer & CEO": {
    "en": "Founder & CEO",
    "ta": "நிறுவனர் மற்றும் தலைமை நிர்வாக அதிகாரி",
    "si": "නිර්මාතෘ සහ ප්‍රධාන විධායක නිලධාරී",
    "hi": "संस्थापक एवं सीईओ",
    "ar": "المؤسس والرئيس التنفيذي",
    "tr": "Kurucu ve CEO",
    "ru": "Основатель и CEO",
    "zh": "创始人兼首席执行官",
    "fr": "Fondateur et PDG",
    "es": "Fundador y director ejecutivo"
  },
  "Konzeption, App-Entwicklung, Design und technische Gesamtleitung.": {
    "en": "Concept, app development, design, and technical leadership.",
    "ta": "திட்டமிடல், செயலி உருவாக்கம், வடிவமைப்பு மற்றும் தொழில்நுட்பத் தலைமை.",
    "si": "සංකල්ප, යෙදුම් සංවර්ධනය, සැලසුම සහ තාක්ෂණික නායකත්වය.",
    "hi": "परिकल्पना, ऐप विकास, डिज़ाइन और तकनीकी नेतृत्व।",
    "ar": "التخطيط وتطوير التطبيق والتصميم والقيادة التقنية.",
    "tr": "Konsept, uygulama geliştirme, tasarım ve teknik yönetim.",
    "ru": "Концепция, разработка приложения, дизайн и техническое руководство.",
    "zh": "产品规划、应用开发、设计和技术领导。",
    "fr": "Conception, développement, design et direction technique.",
    "es": "Concepto, desarrollo de apps, diseño y dirección técnica."
  },
  "GESCHÄFTSFÜHRUNG & INHALTE": {
    "en": "MANAGEMENT & CONTENT",
    "ta": "நிர்வாகம் மற்றும் உள்ளடக்கம்",
    "si": "කළමනාකරණය සහ අන්තර්ගතය",
    "hi": "प्रबंधन और सामग्री",
    "ar": "الإدارة والمحتوى",
    "tr": "YÖNETİM VE İÇERİK",
    "ru": "УПРАВЛЕНИЕ И КОНТЕНТ",
    "zh": "管理与内容",
    "fr": "DIRECTION ET CONTENUS",
    "es": "GESTIÓN Y CONTENIDOS"
  },
  "Geschäftsführerin": {
    "en": "Managing director",
    "ta": "நிர்வாக இயக்குநர்",
    "si": "කළමනාකාර අධ්‍යක්ෂ",
    "hi": "प्रबंध निदेशक",
    "ar": "المديرة الإدارية",
    "tr": "Genel müdür",
    "ru": "Управляющий директор",
    "zh": "总经理",
    "fr": "Directrice générale",
    "es": "Directora general"
  },
  "Deutschlektorat und inhaltliche Qualitätssicherung.": {
    "en": "German-language editing and content quality assurance.",
    "ta": "ஜெர்மன் மொழித் திருத்தம் மற்றும் உள்ளடக்கத் தர உறுதி.",
    "si": "ජර්මන් භාෂා සංස්කරණය සහ අන්තර්ගත තත්ත්ව සහතිකය.",
    "hi": "जर्मन भाषा संपादन और सामग्री गुणवत्ता जाँच।",
    "ar": "مراجعة اللغة الألمانية وضمان جودة المحتوى.",
    "tr": "Almanca dil düzenlemesi ve içerik kalite kontrolü.",
    "ru": "Редактура немецкого языка и контроль качества материалов.",
    "zh": "德语审校和内容质量保证。",
    "fr": "Révision de l’allemand et contrôle qualité des contenus.",
    "es": "Revisión del alemán y control de calidad del contenido."
  },
  "TECHNISCHE BERATUNG": {
    "en": "TECHNICAL CONSULTING",
    "ta": "தொழில்நுட்ப ஆலோசனை",
    "si": "තාක්ෂණික උපදේශනය",
    "hi": "तकनीकी परामर्श",
    "ar": "الاستشارات التقنية",
    "tr": "TEKNİK DANIŞMANLIK",
    "ru": "ТЕХНИЧЕСКИЕ КОНСУЛЬТАЦИИ",
    "zh": "技术咨询",
    "fr": "CONSEIL TECHNIQUE",
    "es": "ASESORÍA TÉCNICA"
  },
  "Technischer Berater": {
    "en": "Technical adviser",
    "ta": "தொழில்நுட்ப ஆலோசகர்",
    "si": "තාක්ෂණික උපදේශක",
    "hi": "तकनीकी सलाहकार",
    "ar": "مستشار تقني",
    "tr": "Teknik danışman",
    "ru": "Технический консультант",
    "zh": "技术顾问",
    "fr": "Conseiller technique",
    "es": "Asesor técnico"
  },
  "Beratung zur Architektur mobiler Anwendungen.": {
    "en": "Advice on mobile application architecture.",
    "ta": "மொபைல் செயலிக் கட்டமைப்புக்கான ஆலோசனை.",
    "si": "ජංගම යෙදුම් ගෘහනිර්මාණය පිළිබඳ උපදෙස්.",
    "hi": "मोबाइल ऐप संरचना पर परामर्श।",
    "ar": "استشارات في بنية تطبيقات الهاتف.",
    "tr": "Mobil uygulama mimarisi danışmanlığı.",
    "ru": "Консультации по архитектуре мобильных приложений.",
    "zh": "提供移动应用架构咨询。",
    "fr": "Conseil en architecture d’applications mobiles.",
    "es": "Asesoría sobre arquitectura de aplicaciones móviles."
  },
  "MOBIL LERNEN": {
    "en": "LEARN ON MOBILE",
    "ta": "மொபைலில் கற்கவும்",
    "si": "ජංගම දුරකථනයෙන් ඉගෙන ගන්න",
    "hi": "मोबाइल पर सीखें",
    "ar": "تعلّم عبر الهاتف",
    "tr": "MOBİLDE ÖĞREN",
    "ru": "УЧИТЕСЬ НА ТЕЛЕФОНЕ",
    "zh": "移动学习",
    "fr": "APPRENDRE SUR MOBILE",
    "es": "APRENDE EN EL MÓVIL"
  },
  "Deine Lernbegleitung für unterwegs": {
    "en": "Your learning companion on the go",
    "ta": "பயணத்திலும் உங்களுடன் இருக்கும் கற்றல் துணை",
    "si": "ගමනේදීත් ඔබේ ඉගෙනුම් සහකරු",
    "hi": "चलते-फिरते आपका सीखने का साथी",
    "ar": "رفيق تعلّمك أثناء التنقل",
    "tr": "Yoldayken öğrenme arkadaşın",
    "ru": "Ваш помощник в обучении везде",
    "zh": "随时随地的学习伙伴",
    "fr": "Votre compagnon d’apprentissage partout",
    "es": "Tu compañero de aprendizaje estés donde estés"
  },
  "Die GERMAN A1-C2 App findest du direkt in den offiziellen App-Stores.": {
    "en": "Find the GERMAN A1-C2 app in the official app stores.",
    "ta": "GERMAN A1-C2 செயலியை அதிகாரப்பூர்வ செயலிக் கடைகளில் பெறலாம்.",
    "si": "GERMAN A1-C2 යෙදුම නිල යෙදුම් වෙළඳසැල්වලින් ලබාගන්න.",
    "hi": "GERMAN A1-C2 ऐप आधिकारिक ऐप स्टोर पर उपलब्ध है।",
    "ar": "يمكنك العثور على تطبيق GERMAN A1-C2 في متاجر التطبيقات الرسمية.",
    "tr": "GERMAN A1-C2 uygulamasını resmî uygulama mağazalarında bul.",
    "ru": "Приложение GERMAN A1-C2 доступно в официальных магазинах приложений.",
    "zh": "可在官方应用商店找到 GERMAN A1-C2 应用。",
    "fr": "Retrouvez l’application GERMAN A1-C2 dans les boutiques officielles.",
    "es": "Encuentra GERMAN A1-C2 en las tiendas oficiales."
  },
  "App Store öffnen": {
    "en": "Open App Store",
    "ta": "App Store-ஐத் திறக்க",
    "si": "App Store විවෘත කරන්න",
    "hi": "App Store खोलें",
    "ar": "فتح App Store",
    "tr": "App Store'u aç",
    "ru": "Открыть App Store",
    "zh": "打开 App Store",
    "fr": "Ouvrir l’App Store",
    "es": "Abrir App Store"
  },
  "Google Play öffnen": {
    "en": "Open Google Play",
    "ta": "Google Play-ஐத் திறக்க",
    "si": "Google Play විවෘත කරන්න",
    "hi": "Google Play खोलें",
    "ar": "فتح Google Play",
    "tr": "Google Play'i aç",
    "ru": "Открыть Google Play",
    "zh": "打开 Google Play",
    "fr": "Ouvrir Google Play",
    "es": "Abrir Google Play"
  },
  "HÄUFIGE FRAGEN": {
    "en": "FREQUENTLY ASKED QUESTIONS",
    "ta": "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    "si": "නිතර අසන ප්‍රශ්න",
    "hi": "अक्सर पूछे जाने वाले प्रश्न",
    "ar": "الأسئلة الشائعة",
    "tr": "SIK SORULAN SORULAR",
    "ru": "ЧАСТЫЕ ВОПРОСЫ",
    "zh": "常见问题",
    "fr": "QUESTIONS FRÉQUENTES",
    "es": "PREGUNTAS FRECUENTES"
  },
  "Antworten rund um das Deutschlernen": {
    "en": "Answers about learning German",
    "ta": "ஜெர்மன் கற்றல் குறித்த பதில்கள்",
    "si": "ජර්මන් ඉගෙනීම පිළිබඳ පිළිතුරු",
    "hi": "जर्मन सीखने से जुड़े उत्तर",
    "ar": "إجابات عن تعلّم الألمانية",
    "tr": "Almanca öğrenmeyle ilgili yanıtlar",
    "ru": "Ответы об изучении немецкого",
    "zh": "关于德语学习的解答",
    "fr": "Réponses sur l’apprentissage de l’allemand",
    "es": "Respuestas sobre el aprendizaje del alemán"
  },
  "NOCH FRAGEN?": {
    "en": "ANY QUESTIONS?",
    "ta": "மேலும் கேள்விகள் உள்ளனவா?",
    "si": "තවත් ප්‍රශ්න තිබේද?",
    "hi": "और प्रश्न हैं?",
    "ar": "هل لديك أسئلة أخرى؟",
    "tr": "BAŞKA SORUN VAR MI?",
    "ru": "ЕСТЬ ЕЩЁ ВОПРОСЫ?",
    "zh": "还有疑问？",
    "fr": "ENCORE DES QUESTIONS ?",
    "es": "¿MÁS PREGUNTAS?"
  },
  "Wir helfen dir, den nächsten Schritt zu finden.": {
    "en": "We'll help you find your next step.",
    "ta": "அடுத்த படியைத் தேர்வுசெய்ய உதவுகிறோம்.",
    "si": "ඊළඟ පියවර සොයාගැනීමට අපි උදව් කරමු.",
    "hi": "हम अगला कदम चुनने में मदद करेंगे।",
    "ar": "سنساعدك على تحديد خطوتك التالية.",
    "tr": "Sonraki adımını bulmana yardım ederiz.",
    "ru": "Мы поможем определить следующий шаг.",
    "zh": "我们将帮助您找到下一步。",
    "fr": "Nous vous aiderons à choisir la prochaine étape.",
    "es": "Te ayudamos a encontrar el siguiente paso."
  },
  "Informationen zu Kursen, Büchern oder deinem Zugang erhältst du über unsere Kontaktseite.": {
    "en": "Get information about courses, books, or your access on our contact page.",
    "ta": "பாடநெறிகள், புத்தகங்கள் அல்லது அணுகல் குறித்த தகவல்களை எங்கள் தொடர்புப் பக்கத்தில் பெறலாம்.",
    "si": "පාඨමාලා, පොත් හෝ ප්‍රවේශය ගැන අපගේ සම්බන්ධතා පිටුවෙන් විමසන්න.",
    "hi": "पाठ्यक्रम, पुस्तकों या पहुँच की जानकारी हमारे संपर्क पृष्ठ पर लें।",
    "ar": "للاستفسار عن الدورات أو الكتب أو الوصول، تواصل معنا عبر صفحة الاتصال.",
    "tr": "Kurslar, kitaplar veya erişimin hakkında iletişim sayfamızdan bilgi al.",
    "ru": "Сведения о курсах, книгах и доступе — на странице контактов.",
    "zh": "通过联系页面了解课程、图书或访问权限。",
    "fr": "Pour les cours, les livres et l’accès, consultez notre page de contact.",
    "es": "Infórmate sobre cursos, libros y acceso en nuestra página de contacto."
  },
  "Kontakt aufnehmen": {
    "en": "Contact us",
    "ta": "எங்களைத் தொடர்புகொள்ள",
    "si": "අප අමතන්න",
    "hi": "संपर्क करें",
    "ar": "اتصل بنا",
    "tr": "İletişime geç",
    "ru": "Связаться с нами",
    "zh": "联系我们",
    "fr": "Nous contacter",
    "es": "Contactar"
  },
  "Passendes Angebot wählen": {
    "en": "Choose the right option",
    "ta": "பொருத்தமான வாய்ப்பைத் தேர்ந்தெடுக்கவும்",
    "si": "ගැළපෙන විකල්පය තෝරන්න",
    "hi": "सही विकल्प चुनें",
    "ar": "اختر الخيار المناسب",
    "tr": "Uygun seçeneği seç",
    "ru": "Выберите подходящий вариант",
    "zh": "选择合适的内容",
    "fr": "Choisir la bonne offre",
    "es": "Elige la opción adecuada"
  },
  "Informiere dich über die Kursniveaus und die Bücherbibliothek.": {
    "en": "Explore course levels and the book library.",
    "ta": "பாடநெறி நிலைகளையும் புத்தக நூலகத்தையும் அறிந்துகொள்ளுங்கள்.",
    "si": "පාඨමාලා මට්ටම් සහ පුස්තකාලය ගැන දැනගන්න.",
    "hi": "पाठ्यक्रम स्तर और पुस्तकालय के बारे में जानें।",
    "ar": "تعرّف إلى مستويات الدورات ومكتبة الكتب.",
    "tr": "Kurs seviyeleri ve kitap kütüphanesi hakkında bilgi edin.",
    "ru": "Узнайте об уровнях курсов и библиотеке.",
    "zh": "了解课程级别和图书馆。",
    "fr": "Découvrez les niveaux et la bibliothèque.",
    "es": "Infórmate sobre los niveles y la biblioteca."
  },
  "Zugang prüfen": {
    "en": "Check access",
    "ta": "அணுகலைச் சரிபார்க்க",
    "si": "ප්‍රවේශය පරීක්ෂා කරන්න",
    "hi": "पहुँच की जाँच करें",
    "ar": "التحقق من الوصول",
    "tr": "Erişimi kontrol et",
    "ru": "Проверить доступ",
    "zh": "核验权限",
    "fr": "Vérifier l’accès",
    "es": "Comprobar acceso"
  },
  "Melde dich mit deinem Konto an. Freigeschaltete Angebote kannst du direkt öffnen.": {
    "en": "Sign in to your account. Open the options you can access.",
    "ta": "உங்கள் கணக்கில் உள்நுழையுங்கள். அனுமதி உள்ள உள்ளடக்கங்களை நேரடியாகத் திறக்கலாம்.",
    "si": "ගිණුමට පිවිසෙන්න. ලබා දී ඇති අයිතම විවෘත කළ හැක.",
    "hi": "खाते में साइन इन करें। उपलब्ध सामग्री सीधे खोलें।",
    "ar": "سجّل الدخول إلى حسابك وافتح المحتوى المتاح لك.",
    "tr": "Hesabına giriş yap. Erişebildiğin içerikleri doğrudan aç.",
    "ru": "Войдите в аккаунт и откройте доступные материалы.",
    "zh": "登录您的账户，直接打开可访问的内容。",
    "fr": "Connectez-vous pour ouvrir les contenus accessibles.",
    "es": "Inicia sesión y abre los contenidos disponibles."
  },
  "Auf Deutsch weiterlernen": {
    "en": "Keep learning German",
    "ta": "ஜெர்மன் கற்றலைத் தொடரவும்",
    "si": "ජර්මන් ඉගෙනීම දිගටම කරගෙන යන්න",
    "hi": "जर्मन सीखना जारी रखें",
    "ar": "واصل تعلّم الألمانية",
    "tr": "Almanca öğrenmeye devam et",
    "ru": "Продолжайте учить немецкий",
    "zh": "继续学习德语",
    "fr": "Continuer à apprendre l’allemand",
    "es": "Sigue aprendiendo alemán"
  },
  "Nutze deine Kurse, Bücher und die täglichen Wortbeispiele.": {
    "en": "Use your courses, books, and daily example words.",
    "ta": "பாடநெறிகள், புத்தகங்கள், தினசரி எடுத்துக்காட்டுச் சொற்களைப் பயன்படுத்துங்கள்.",
    "si": "පාඨමාලා, පොත් සහ දිනපතා වචන භාවිත කරන්න.",
    "hi": "पाठ्यक्रम, पुस्तकें और दैनिक उदाहरण शब्द उपयोग करें।",
    "ar": "استخدم دوراتك وكتبك وأمثلة الكلمات اليومية.",
    "tr": "Kurslarını, kitaplarını ve günlük örnek kelimeleri kullan.",
    "ru": "Используйте курсы, книги и примеры слов на каждый день.",
    "zh": "使用课程、图书和每日单词示例。",
    "fr": "Utilisez vos cours, livres et exemples quotidiens.",
    "es": "Usa tus cursos, libros y ejemplos diarios."
  },
  "Anfänger": {
    "en": "Beginner",
    "ta": "தொடக்கநிலை",
    "si": "ආරම්භක",
    "hi": "शुरुआती",
    "ar": "مبتدئ",
    "tr": "Başlangıç",
    "ru": "Начальный",
    "zh": "初学者",
    "fr": "Débutant",
    "es": "Principiante"
  },
  "Grundlagen": {
    "en": "Elementary",
    "ta": "அடிப்படைநிலை",
    "si": "මූලික",
    "hi": "प्रारंभिक",
    "ar": "أساسي",
    "tr": "Temel",
    "ru": "Базовый",
    "zh": "基础",
    "fr": "Élémentaire",
    "es": "Básico"
  },
  "Mittelstufe": {
    "en": "Intermediate",
    "ta": "இடைநிலை",
    "si": "මධ්‍යම",
    "hi": "मध्यम",
    "ar": "متوسط",
    "tr": "Orta",
    "ru": "Средний",
    "zh": "中级",
    "fr": "Intermédiaire",
    "es": "Intermedio"
  },
  "Oberstufe": {
    "en": "Upper intermediate",
    "ta": "மேல்நிலை",
    "si": "ඉහළ මධ්‍යම",
    "hi": "उच्च मध्यम",
    "ar": "فوق المتوسط",
    "tr": "Üst orta",
    "ru": "Выше среднего",
    "zh": "中高级",
    "fr": "Intermédiaire supérieur",
    "es": "Intermedio alto"
  },
  "Profi": {
    "en": "Advanced",
    "ta": "மேம்பட்ட நிலை",
    "si": "උසස්",
    "hi": "उन्नत",
    "ar": "متقدم",
    "tr": "İleri",
    "ru": "Продвинутый",
    "zh": "高级",
    "fr": "Avancé",
    "es": "Avanzado"
  },
  "Experte": {
    "en": "Proficient",
    "ta": "நிபுணர் நிலை",
    "si": "ප්‍රවීණ",
    "hi": "विशेषज्ञ",
    "ar": "خبير",
    "tr": "Uzman",
    "ru": "Эксперт",
    "zh": "精通",
    "fr": "Expert",
    "es": "Experto"
  },
  "Freigeschaltet": {
    "en": "Unlocked",
    "ta": "திறக்கப்பட்டது",
    "si": "විවෘත කර ඇත",
    "hi": "अनलॉक",
    "ar": "مفتوح",
    "tr": "Erişilebilir",
    "ru": "Открыто",
    "zh": "已解锁",
    "fr": "Débloqué",
    "es": "Desbloqueado"
  },
  "Gesperrt": {
    "en": "Locked",
    "ta": "பூட்டப்பட்டது",
    "si": "අගුළු දමා ඇත",
    "hi": "लॉक",
    "ar": "مقفل",
    "tr": "Kilitli",
    "ru": "Заблокировано",
    "zh": "已锁定",
    "fr": "Verrouillé",
    "es": "Bloqueado"
  },
  "Freigeschaltete Bücher": {
    "en": "Unlocked books",
    "ta": "திறக்கப்பட்ட புத்தகங்கள்",
    "si": "විවෘත පොත්",
    "hi": "अनलॉक पुस्तकें",
    "ar": "الكتب المفتوحة",
    "tr": "Açık kitaplar",
    "ru": "Доступные книги",
    "zh": "已解锁图书",
    "fr": "Livres débloqués",
    "es": "Libros desbloqueados"
  },
  "Freigeschaltete Kurse": {
    "en": "Unlocked courses",
    "ta": "திறக்கப்பட்ட பாடநெறிகள்",
    "si": "විවෘත පාඨමාලා",
    "hi": "अनलॉक पाठ्यक्रम",
    "ar": "الدورات المفتوحة",
    "tr": "Açık kurslar",
    "ru": "Доступные курсы",
    "zh": "已解锁课程",
    "fr": "Cours débloqués",
    "es": "Cursos desbloqueados"
  },
  "Deutschbibliothek": {
    "en": "German library",
    "ta": "ஜெர்மன் புத்தக நூலகம்",
    "si": "ජර්මන් පුස්තකාලය",
    "hi": "जर्मन पुस्तकालय",
    "ar": "مكتبة الألمانية",
    "tr": "Almanca kütüphanesi",
    "ru": "Библиотека немецкого",
    "zh": "德语图书馆",
    "fr": "Bibliothèque allemande",
    "es": "Biblioteca de alemán"
  },
  "Meine Deutschbücher": {
    "en": "My German books",
    "ta": "எனது ஜெர்மன் புத்தகங்கள்",
    "si": "මගේ ජර්මන් පොත්",
    "hi": "मेरी जर्मन पुस्तकें",
    "ar": "كتبي الألمانية",
    "tr": "Almanca kitaplarım",
    "ru": "Мои книги по немецкому",
    "zh": "我的德语图书",
    "fr": "Mes livres d’allemand",
    "es": "Mis libros de alemán"
  },
  "Freigeschaltete Bücher können geöffnet werden. Gesperrte Bücher benötigen Premium-Zugang.": {
    "en": "Unlocked books can be opened. Locked books require Premium access.",
    "ta": "திறக்கப்பட்ட புத்தகங்களைப் பார்க்கலாம். பூட்டப்பட்ட புத்தகங்களுக்கு பிரீமியம் அணுகல் தேவை.",
    "si": "විවෘත කළ පොත් බැලිය හැක. අගුළු දැමූ පොත් සඳහා ප්‍රිමියම් ප්‍රවේශය අවශ්‍යයි.",
    "hi": "अनलॉक पुस्तकें खोली जा सकती हैं। लॉक पुस्तकों के लिए प्रीमियम पहुँच चाहिए।",
    "ar": "يمكن فتح الكتب المتاحة. تتطلب الكتب المقفلة وصولًا مميزًا.",
    "tr": "Erişimin olan kitapları açabilirsin. Kilitli kitaplar Premium erişim gerektirir.",
    "ru": "Доступные книги можно открыть. Для закрытых нужен Премиум.",
    "zh": "已解锁的图书可以打开。锁定图书需要高级会员权限。",
    "fr": "Les livres débloqués peuvent être ouverts. Les livres verrouillés nécessitent Premium.",
    "es": "Puedes abrir libros desbloqueados. Los libros bloqueados requieren acceso prémium."
  },
  "Daten aktualisieren": {
    "en": "Refresh data",
    "ta": "தகவல்களைப் புதுப்பிக்க",
    "si": "දත්ත යාවත්කාලීන කරන්න",
    "hi": "डेटा अपडेट करें",
    "ar": "تحديث البيانات",
    "tr": "Verileri güncelle",
    "ru": "Обновить данные",
    "zh": "刷新数据",
    "fr": "Actualiser les données",
    "es": "Actualizar datos"
  },
  "Erneut prüfen": {
    "en": "Check again",
    "ta": "மீண்டும் சரிபார்க்க",
    "si": "නැවත පරීක්ෂා කරන්න",
    "hi": "फिर जाँचें",
    "ar": "إعادة التحقق",
    "tr": "Tekrar kontrol et",
    "ru": "Проверить ещё раз",
    "zh": "再次检查",
    "fr": "Vérifier à nouveau",
    "es": "Comprobar de nuevo"
  },
  "Bitte erneut versuchen": {
    "en": "Please try again",
    "ta": "மீண்டும் முயற்சிக்கவும்",
    "si": "නැවත උත්සාහ කරන්න",
    "hi": "कृपया फिर कोशिश करें",
    "ar": "يرجى المحاولة مجددًا",
    "tr": "Lütfen tekrar dene",
    "ru": "Попробуйте снова",
    "zh": "请重试",
    "fr": "Veuillez réessayer",
    "es": "Inténtalo de nuevo"
  },
  "Fehler": {
    "en": "Error",
    "ta": "பிழை",
    "si": "දෝෂය",
    "hi": "त्रुटि",
    "ar": "خطأ",
    "tr": "Hata",
    "ru": "Ошибка",
    "zh": "错误",
    "fr": "Erreur",
    "es": "Error"
  },
  "Zugang wird geprüft": {
    "en": "Checking access",
    "ta": "அணுகல் சரிபார்க்கப்படுகிறது",
    "si": "ප්‍රවේශය පරීක්ෂා කෙරේ",
    "hi": "पहुँच की जाँच हो रही है",
    "ar": "جارٍ التحقق من الوصول",
    "tr": "Erişim kontrol ediliyor",
    "ru": "Проверка доступа",
    "zh": "正在核验权限",
    "fr": "Vérification de l’accès",
    "es": "Comprobando acceso"
  },
  "Anmeldung erforderlich": {
    "en": "Sign-in required",
    "ta": "உள்நுழைவு அவசியம்",
    "si": "පිවිසීම අවශ්‍යයි",
    "hi": "साइन इन आवश्यक है",
    "ar": "يلزم تسجيل الدخول",
    "tr": "Giriş yapmalısın",
    "ru": "Требуется вход",
    "zh": "需要登录",
    "fr": "Connexion requise",
    "es": "Debes iniciar sesión"
  },
  "Jetzt einloggen": {
    "en": "Sign in now",
    "ta": "இப்போது உள்நுழைய",
    "si": "දැන් පිවිසෙන්න",
    "hi": "अभी साइन इन करें",
    "ar": "سجّل الدخول الآن",
    "tr": "Şimdi giriş yap",
    "ru": "Войти сейчас",
    "zh": "立即登录",
    "fr": "Se connecter maintenant",
    "es": "Iniciar sesión ahora"
  },
  "Konto und Zugang werden geprüft...": {
    "en": "Checking account and access...",
    "ta": "கணக்கும் அணுகலும் சரிபார்க்கப்படுகின்றன...",
    "si": "ගිණුම හා ප්‍රවේශය පරීක්ෂා කෙරේ...",
    "hi": "खाता और पहुँच जाँची जा रही है...",
    "ar": "جارٍ التحقق من الحساب والوصول...",
    "tr": "Hesap ve erişim kontrol ediliyor...",
    "ru": "Проверка аккаунта и доступа...",
    "zh": "正在检查账户和权限...",
    "fr": "Vérification du compte et de l’accès...",
    "es": "Comprobando cuenta y acceso..."
  },
  "Erstellt": {
    "en": "Created",
    "ta": "உருவாக்கப்பட்டது",
    "si": "නිර්මාණය කළ දිනය",
    "hi": "बनाया गया",
    "ar": "تاريخ الإنشاء",
    "tr": "Oluşturulma",
    "ru": "Создано",
    "zh": "创建时间",
    "fr": "Créé le",
    "es": "Creado"
  },
  "Letzte Anmeldung": {
    "en": "Last sign-in",
    "ta": "கடைசியாக உள்நுழைந்தது",
    "si": "අවසන් පිවිසීම",
    "hi": "पिछला लॉगिन",
    "ar": "آخر تسجيل دخول",
    "tr": "Son giriş",
    "ru": "Последний вход",
    "zh": "上次登录",
    "fr": "Dernière connexion",
    "es": "Último inicio de sesión"
  },
  "Zugang geprüft": {
    "en": "Access checked",
    "ta": "அணுகல் சரிபார்க்கப்பட்டது",
    "si": "ප්‍රවේශය පරීක්ෂා කළා",
    "hi": "पहुँच जाँची गई",
    "ar": "تم التحقق من الوصول",
    "tr": "Erişim kontrol edildi",
    "ru": "Доступ проверен",
    "zh": "权限已核验",
    "fr": "Accès vérifié",
    "es": "Acceso comprobado"
  },
  "Kein Abo": {
    "en": "No subscription",
    "ta": "சந்தா இல்லை",
    "si": "දායකත්වයක් නැත",
    "hi": "सदस्यता नहीं",
    "ar": "لا يوجد اشتراك",
    "tr": "Abonelik yok",
    "ru": "Нет подписки",
    "zh": "无订阅",
    "fr": "Aucun abonnement",
    "es": "Sin suscripción"
  },
  "Kein Zugang": {
    "en": "No access",
    "ta": "அணுகல் இல்லை",
    "si": "ප්‍රවේශයක් නැත",
    "hi": "पहुँच नहीं",
    "ar": "لا يوجد وصول",
    "tr": "Erişim yok",
    "ru": "Нет доступа",
    "zh": "无权限",
    "fr": "Aucun accès",
    "es": "Sin acceso"
  },
  "Manueller Zugang aktiv": {
    "en": "Manual access active",
    "ta": "கைமுறை அணுகல் செயலில் உள்ளது",
    "si": "අතින් ලබා දුන් ප්‍රවේශය ක්‍රියාත්මකයි",
    "hi": "मैनुअल पहुँच सक्रिय है",
    "ar": "الوصول اليدوي نشط",
    "tr": "Manuel erişim etkin",
    "ru": "Ручной доступ активен",
    "zh": "手动权限已启用",
    "fr": "Accès manuel actif",
    "es": "Acceso manual activo"
  },
  "Website-Abo verwalten": {
    "en": "Manage website subscription",
    "ta": "இணையதளச் சந்தாவை நிர்வகிக்க",
    "si": "වෙබ් දායකත්වය කළමනාකරණය කරන්න",
    "hi": "वेबसाइट सदस्यता प्रबंधित करें",
    "ar": "إدارة اشتراك الموقع",
    "tr": "Web sitesi aboneliğini yönet",
    "ru": "Управление подпиской сайта",
    "zh": "管理网站订阅",
    "fr": "Gérer l’abonnement au site",
    "es": "Gestionar suscripción web"
  },
  "freigeschaltete Bücher": {
    "en": "unlocked books",
    "ta": "திறக்கப்பட்ட புத்தகங்கள்",
    "si": "විවෘත පොත්",
    "hi": "अनलॉक पुस्तकें",
    "ar": "الكتب المفتوحة",
    "tr": "erişilebilir kitaplar",
    "ru": "доступные книги",
    "zh": "已解锁图书",
    "fr": "livres débloqués",
    "es": "libros desbloqueados"
  },
  "freigeschaltete Kurse": {
    "en": "unlocked courses",
    "ta": "திறக்கப்பட்ட பாடநெறிகள்",
    "si": "විවෘත පාඨමාලා",
    "hi": "अनलॉक पाठ्यक्रम",
    "ar": "الدورات المفتوحة",
    "tr": "erişilebilir kurslar",
    "ru": "доступные курсы",
    "zh": "已解锁课程",
    "fr": "cours débloqués",
    "es": "cursos desbloqueados"
  },
  "Keine Bücher": {
    "en": "No books",
    "ta": "புத்தகங்கள் இல்லை",
    "si": "පොත් නැත",
    "hi": "कोई पुस्तक नहीं",
    "ar": "لا توجد كتب",
    "tr": "Kitap yok",
    "ru": "Нет книг",
    "zh": "无图书",
    "fr": "Aucun livre",
    "es": "Sin libros"
  },
  "Kein Kursabo": {
    "en": "No course subscription",
    "ta": "பாடநெறிச் சந்தா இல்லை",
    "si": "පාඨමාලා දායකත්වයක් නැත",
    "hi": "कोई पाठ्यक्रम सदस्यता नहीं",
    "ar": "لا يوجد اشتراك بالدورات",
    "tr": "Kurs aboneliği yok",
    "ru": "Нет подписки на курс",
    "zh": "无课程订阅",
    "fr": "Aucun abonnement aux cours",
    "es": "Sin suscripción a cursos"
  },
  "Kurszugang kaufen": {
    "en": "Buy course access",
    "ta": "பாடநெறி அணுகலை வாங்க",
    "si": "පාඨමාලා ප්‍රවේශය මිලදී ගන්න",
    "hi": "पाठ्यक्रम की पहुँच खरीदें",
    "ar": "شراء الوصول إلى الدورة",
    "tr": "Kurs erişimi satın al",
    "ru": "Купить доступ к курсу",
    "zh": "购买课程权限",
    "fr": "Acheter l’accès au cours",
    "es": "Comprar acceso al curso"
  },
  "Sichere Zahlung": {
    "en": "Secure payment",
    "ta": "பாதுகாப்பான கட்டணம்",
    "si": "ආරක්ෂිත ගෙවීම",
    "hi": "सुरक्षित भुगतान",
    "ar": "دفع آمن",
    "tr": "Güvenli ödeme",
    "ru": "Безопасная оплата",
    "zh": "安全付款",
    "fr": "Paiement sécurisé",
    "es": "Pago seguro"
  },
  "Zahlungsart": {
    "en": "Payment method",
    "ta": "கட்டண முறை",
    "si": "ගෙවීම් ක්‍රමය",
    "hi": "भुगतान का तरीका",
    "ar": "طريقة الدفع",
    "tr": "Ödeme yöntemi",
    "ru": "Способ оплаты",
    "zh": "付款方式",
    "fr": "Mode de paiement",
    "es": "Método de pago"
  },
  "Monatlich": {
    "en": "Monthly",
    "ta": "மாதந்தோறும்",
    "si": "මාසික",
    "hi": "मासिक",
    "ar": "شهريًا",
    "tr": "Aylık",
    "ru": "Ежемесячно",
    "zh": "每月",
    "fr": "Mensuel",
    "es": "Mensual"
  },
  "Preis": {
    "en": "Price",
    "ta": "விலை",
    "si": "මිල",
    "hi": "कीमत",
    "ar": "السعر",
    "tr": "Fiyat",
    "ru": "Цена",
    "zh": "价格",
    "fr": "Prix",
    "es": "Precio"
  },
  "Bitte warten": {
    "en": "Please wait",
    "ta": "காத்திருக்கவும்",
    "si": "රැඳී සිටින්න",
    "hi": "कृपया प्रतीक्षा करें",
    "ar": "يرجى الانتظار",
    "tr": "Lütfen bekle",
    "ru": "Подождите",
    "zh": "请稍候",
    "fr": "Veuillez patienter",
    "es": "Espera, por favor"
  },
  "Hinweis:": {
    "en": "Note:",
    "ta": "குறிப்பு:",
    "si": "සටහන:",
    "hi": "सूचना:",
    "ar": "ملاحظة:",
    "tr": "Not:",
    "ru": "Примечание:",
    "zh": "提示：",
    "fr": "Remarque :",
    "es": "Nota:"
  },
  "Alle Rechte vorbehalten.": {
    "en": "All rights reserved.",
    "ta": "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    "si": "සියලු හිමිකම් ඇවිරිණි.",
    "hi": "सर्वाधिकार सुरक्षित।",
    "ar": "جميع الحقوق محفوظة.",
    "tr": "Tüm hakları saklıdır.",
    "ru": "Все права защищены.",
    "zh": "版权所有。",
    "fr": "Tous droits réservés.",
    "es": "Todos los derechos reservados."
  },
  "Wenn Sie ein Problem mit Login, Premium-Zugang, Büchern, Kursen oder Zahlungen haben, kontaktieren Sie uns bitte. Wir helfen Ihnen so schnell wie möglich.": {
    "en": "If you have a problem with login, Premium access, books, courses, or payments, please contact us. We'll help as quickly as possible.",
    "ta": "உள்நுழைவு, பிரீமியம் அணுகல், புத்தகங்கள், பாடநெறிகள் அல்லது கட்டணம் தொடர்பாக சிக்கல் இருந்தால் எங்களைத் தொடர்புகொள்ளுங்கள். விரைவாக உதவ முயற்சிப்போம்.",
    "si": "පිවිසීම, ප්‍රිමියම්, පොත්, පාඨමාලා හෝ ගෙවීම් ගැන ගැටලුවක් නම් අප අමතන්න. හැකි ඉක්මනින් උදව් කරන්නෙමු.",
    "hi": "लॉगिन, प्रीमियम पहुँच, किताबों, पाठ्यक्रमों या भुगतान में समस्या हो तो हमसे संपर्क करें। हम जल्द से जल्द मदद करेंगे।",
    "ar": "إذا واجهت مشكلة في تسجيل الدخول أو الوصول المميز أو الكتب أو الدورات أو المدفوعات، فتواصل معنا. سنساعدك بأسرع وقت ممكن.",
    "tr": "Giriş, Premium erişim, kitaplar, kurslar veya ödemelerle ilgili sorunun varsa bize ulaş. En kısa sürede yardımcı olacağız.",
    "ru": "Если есть проблемы со входом, Премиумом, книгами, курсами или оплатой, свяжитесь с нами. Мы постараемся помочь как можно скорее.",
    "zh": "如果登录、高级会员、图书、课程或付款遇到问题，请联系我们。我们会尽快帮助您。",
    "fr": "Si vous avez un problème de connexion, d’accès Premium, de livres, de cours ou de paiement, contactez-nous. Nous vous aiderons au plus vite.",
    "es": "Si tienes problemas de inicio de sesión, acceso prémium, libros, cursos o pagos, contáctanos. Te ayudaremos lo antes posible."
  },
  "Direkt": {
    "en": "Direct",
    "ta": "நேரடியாக",
    "si": "සෘජුව",
    "hi": "सीधे",
    "ar": "مباشر",
    "tr": "Doğrudan",
    "ru": "Напрямую",
    "zh": "直接联系",
    "fr": "Direct",
    "es": "Directo"
  },
  "3 Wege": {
    "en": "3 ways",
    "ta": "3 வழிகள்",
    "si": "ක්‍රම 3ක්",
    "hi": "3 तरीके",
    "ar": "3 طرق",
    "tr": "3 yöntem",
    "ru": "3 способа",
    "zh": "3 种方式",
    "fr": "3 moyens",
    "es": "3 vías"
  },
  "Bereiche": {
    "en": "Categories",
    "ta": "பிரிவுகள்",
    "si": "කාණ්ඩ",
    "hi": "श्रेणियाँ",
    "ar": "الفئات",
    "tr": "Kategoriler",
    "ru": "Разделы",
    "zh": "类别",
    "fr": "Catégories",
    "es": "Categorías"
  },
  "4 Themen": {
    "en": "4 topics",
    "ta": "4 தலைப்புகள்",
    "si": "මාතෘකා 4ක්",
    "hi": "4 विषय",
    "ar": "4 مواضيع",
    "tr": "4 konu",
    "ru": "4 темы",
    "zh": "4 个主题",
    "fr": "4 sujets",
    "es": "4 temas"
  },
  "Hilfe bei Premium, Kündigung, Abo-Status und Zugang.": {
    "en": "Help with Premium, cancellation, subscription status, and access.",
    "ta": "பிரீமியம், ரத்துசெய்தல், சந்தா நிலை, அணுகல் ஆகியவற்றுக்கான உதவி.",
    "si": "ප්‍රිමියම්, අවලංගු කිරීම්, දායකත්ව තත්ත්වය සහ ප්‍රවේශය ගැන උදව්.",
    "hi": "प्रीमियम, रद्द करने, सदस्यता की स्थिति और पहुँच में सहायता।",
    "ar": "المساعدة بشأن بريميوم والإلغاء وحالة الاشتراك والوصول.",
    "tr": "Premium, iptal, abonelik durumu ve erişim konusunda yardım.",
    "ru": "Помощь по Премиуму, отмене подписки, её статусу и доступу.",
    "zh": "关于高级会员、取消订阅、订阅状态和权限的帮助。",
    "fr": "Aide pour Premium, résiliation, statut d’abonnement et accès.",
    "es": "Ayuda con prémium, cancelaciones, estado de suscripción y acceso."
  },
  "Hilfe, wenn Bücher oder Niveaus nicht richtig öffnen.": {
    "en": "Help when books or levels do not open correctly.",
    "ta": "புத்தகங்கள் அல்லது நிலைகள் சரியாகத் திறக்காதபோது உதவி.",
    "si": "පොත් හෝ මට්ටම් නිසි ලෙස නොවිවෘත වුවහොත් උදව්.",
    "hi": "किताबें या स्तर ठीक से नहीं खुलने पर सहायता।",
    "ar": "المساعدة إذا لم تُفتح الكتب أو المستويات بشكل صحيح.",
    "tr": "Kitaplar veya seviyeler doğru açılmadığında yardım.",
    "ru": "Помощь, если книги или уровни не открываются.",
    "zh": "图书或级别无法正常打开时的帮助。",
    "fr": "Aide lorsque les livres ou niveaux ne s’ouvrent pas correctement.",
    "es": "Ayuda si no se abren correctamente libros o niveles."
  },
  "Fragen zu A1, A2, B1, B2 und Kursfreischaltung.": {
    "en": "Questions about A1, A2, B1, B2, and unlocking courses.",
    "ta": "A1, A2, B1, B2 மற்றும் பாடநெறி திறப்பு குறித்த கேள்விகள்.",
    "si": "A1, A2, B1, B2 සහ පාඨමාලා විවෘත කිරීම ගැන ප්‍රශ්න.",
    "hi": "A1, A2, B1, B2 और पाठ्यक्रम अनलॉक करने पर प्रश्न।",
    "ar": "أسئلة عن A1 وA2 وB1 وB2 وفتح الدورات.",
    "tr": "A1, A2, B1, B2 ve kurs erişimi hakkında sorular.",
    "ru": "Вопросы по A1, A2, B1, B2 и открытию курсов.",
    "zh": "有关 A1、A2、B1、B2 及课程解锁的问题。",
    "fr": "Questions sur A1, A2, B1, B2 et le déblocage des cours.",
    "es": "Consultas sobre A1, A2, B1, B2 y desbloqueo de cursos."
  },
  "Wir antworten so schnell wie möglich.": {
    "en": "We reply as quickly as possible.",
    "ta": "முடிந்தவரை விரைவாகப் பதிலளிப்போம்.",
    "si": "හැකි ඉක්මනින් පිළිතුරු දෙන්නෙමු.",
    "hi": "हम यथाशीघ्र उत्तर देंगे।",
    "ar": "سنرد بأسرع وقت ممكن.",
    "tr": "En kısa sürede yanıt veriyoruz.",
    "ru": "Мы отвечаем как можно быстрее.",
    "zh": "我们会尽快回复。",
    "fr": "Nous répondons dès que possible.",
    "es": "Respondemos lo antes posible."
  },
  "Bitte schreiben Sie Ihre E-Mail-Adresse, Ihr Problem und den Bereich, bei dem Sie Hilfe brauchen. So können wir Ihren Zugang schneller prüfen.": {
    "en": "Please include your email address, the problem, and the area where you need help, so we can check access faster.",
    "ta": "உங்கள் மின்னஞ்சல் முகவரி, பிரச்சினை மற்றும் உதவி தேவைப்படும் பகுதியைக் குறிப்பிடுங்கள். அதனால் அணுகலை விரைவில் சரிபார்க்கலாம்.",
    "si": "ඔබේ ඊමේල් ලිපිනය, ගැටලුව සහ උදව් අවශ්‍ය අංශය සඳහන් කරන්න. එවිට ප්‍රවේශය ඉක්මනින් පරීක්ෂා කළ හැක.",
    "hi": "अपना ईमेल, समस्या और सहायता का क्षेत्र बताएँ ताकि हम पहुँच जल्दी जाँच सकें।",
    "ar": "يرجى ذكر بريدك الإلكتروني والمشكلة والقسم الذي تحتاج فيه للمساعدة لنتحقق من الوصول سريعًا.",
    "tr": "E-posta adresini, sorununu ve yardım istediğin alanı yaz. Böylece erişimini daha hızlı kontrol edebiliriz.",
    "ru": "Укажите адрес электронной почты, проблему и область, где нужна помощь, чтобы мы быстрее проверили доступ.",
    "zh": "请提供邮箱地址、具体问题和需要帮助的类别，以便快速核验权限。",
    "fr": "Indiquez votre adresse e-mail, votre problème et la rubrique concernée pour accélérer la vérification de votre accès.",
    "es": "Indica tu correo electrónico, problema y área de ayuda para que podamos comprobar tu acceso antes."
  },
  "Bücher und Kurse werden getrennt geprüft. Website Premium und App-Premium schalten alle Bücher frei, aber keine Deutschkurse.": {
    "en": "Books and courses are checked separately. Website and app Premium unlock all books, but not German courses.",
    "ta": "புத்தகங்களுக்கும் பாடநெறிகளுக்கும் தனித்தனியாக அணுகல் சரிபார்க்கப்படும். இணையதள மற்றும் செயலிப் பிரீமியம் எல்லாப் புத்தகங்களையும் திறக்கும்; ஜெர்மன் பாடநெறிகளை அல்ல.",
    "si": "පොත් හා පාඨමාලා වෙන වෙනම පරීක්ෂා කෙරේ. වෙබ් හා යෙදුම් ප්‍රිමියම් සියලු පොත් විවෘත කරයි, ජර්මන් පාඨමාලා නොවේ.",
    "hi": "किताबों और पाठ्यक्रमों की पहुँच अलग-अलग जाँची जाती है। वेबसाइट और ऐप प्रीमियम सभी किताबें खोलते हैं, जर्मन पाठ्यक्रम नहीं।",
    "ar": "يُتحقق من الكتب والدورات بشكل منفصل. يفتح بريميوم الموقع والتطبيق جميع الكتب، وليس دورات الألمانية.",
    "tr": "Kitap ve kurs erişimi ayrı kontrol edilir. Web sitesi ve uygulama Premium tüm kitapları açar, Almanca kurslarını açmaz.",
    "ru": "Книги и курсы проверяются отдельно. Премиум сайта и приложения открывает все книги, но не курсы немецкого.",
    "zh": "图书与课程权限分别核验。网站和应用高级会员可解锁所有图书，但不包含德语课程。",
    "fr": "Les accès aux livres et aux cours sont vérifiés séparément. Premium site et application débloquent les livres, pas les cours d’allemand.",
    "es": "El acceso a libros y cursos se comprueba por separado. Prémium web y app desbloquean todos los libros, pero no los cursos de alemán."
  },
  "Bitte loggen Sie sich ein, um Ihr Profil zu sehen.": {
    "en": "Please sign in to view your profile.",
    "ta": "உங்கள் சுயவிவரத்தைப் பார்க்க உள்நுழையுங்கள்.",
    "si": "පැතිකඩ බැලීමට පිවිසෙන්න.",
    "hi": "प्रोफ़ाइल देखने के लिए साइन इन करें।",
    "ar": "سجّل الدخول لعرض ملفك الشخصي.",
    "tr": "Profilini görmek için giriş yap.",
    "ru": "Войдите, чтобы просмотреть профиль.",
    "zh": "请登录以查看个人资料。",
    "fr": "Connectez-vous pour voir votre profil.",
    "es": "Inicia sesión para ver tu perfil."
  },
  "Website Premium und App-Premium schalten nur Bücher frei": {
    "en": "Website and app Premium unlock books only",
    "ta": "இணையதள மற்றும் செயலிப் பிரீமியம் புத்தகங்களை மட்டுமே திறக்கும்",
    "si": "වෙබ් සහ යෙදුම් ප්‍රිමියම් පොත් පමණක් විවෘත කරයි",
    "hi": "वेबसाइट और ऐप प्रीमियम केवल पुस्तकें अनलॉक करते हैं",
    "ar": "بريميوم الموقع والتطبيق يفتح الكتب فقط",
    "tr": "Web sitesi ve uygulama Premium yalnızca kitapları açar",
    "ru": "Премиум сайта и приложения открывает только книги",
    "zh": "网站和应用高级会员仅解锁图书",
    "fr": "Premium site et application débloquent uniquement les livres",
    "es": "Prémium web y app solo desbloquean libros"
  },
  "Für diese E-Mail wurde kein Premium-Abo und kein manueller Zugang gefunden.": {
    "en": "No Premium subscription or manual access was found for this email.",
    "ta": "இந்த மின்னஞ்சலுக்குப் பிரீமியம் சந்தாவோ கைமுறை அணுகலோ இல்லை.",
    "si": "මෙම ඊමේල් ලිපිනයට ප්‍රිමියම් දායකත්වයක් හෝ අතින් ප්‍රවේශයක් හමු නොවීය.",
    "hi": "इस ईमेल के लिए कोई प्रीमियम सदस्यता या मैनुअल पहुँच नहीं मिली।",
    "ar": "لم يُعثر على اشتراك مميز أو وصول يدوي لهذا البريد الإلكتروني.",
    "tr": "Bu e-posta için Premium aboneliği veya manuel erişim bulunamadı.",
    "ru": "Для этого адреса не найдена Премиум-подписка или ручной доступ.",
    "zh": "未找到该邮箱对应的高级会员订阅或手动权限。",
    "fr": "Aucun abonnement Premium ou accès manuel trouvé pour cette adresse.",
    "es": "No se encontró suscripción prémium ni acceso manual para este correo."
  },
  "2 Monate": {
    "en": "2 months",
    "ta": "2 மாதங்கள்",
    "si": "මාස 2ක්",
    "hi": "2 महीने",
    "ar": "شهران",
    "tr": "2 ay",
    "ru": "2 месяца",
    "zh": "2 个月",
    "fr": "2 mois",
    "es": "2 meses"
  },
  "3 Monate": {
    "en": "3 months",
    "ta": "3 மாதங்கள்",
    "si": "මාස 3ක්",
    "hi": "3 महीने",
    "ar": "3 أشهر",
    "tr": "3 ay",
    "ru": "3 месяца",
    "zh": "3 个月",
    "fr": "3 mois",
    "es": "3 meses"
  },
  "2x pro Woche à 2 Stunden": {
    "en": "2 hours twice a week",
    "ta": "வாரத்திற்கு இருமுறை, தலா 2 மணி நேரம்",
    "si": "සතියකට දෙවරක් පැය 2 බැගින්",
    "hi": "सप्ताह में दो बार, प्रत्येक 2 घंटे",
    "ar": "مرتين أسبوعيًا، ساعتان لكل مرة",
    "tr": "Haftada iki kez 2'şer saat",
    "ru": "2 раза в неделю по 2 часа",
    "zh": "每周两次，每次 2 小时",
    "fr": "2 fois par semaine, 2 heures par séance",
    "es": "2 veces por semana, 2 horas por clase"
  },
  "Deutsch & Englisch": {
    "en": "German & English",
    "ta": "ஜெர்மன் மற்றும் ஆங்கிலம்",
    "si": "ජර්මන් සහ ඉංග්‍රීසි",
    "hi": "जर्मन और अंग्रेज़ी",
    "ar": "الألمانية والإنجليزية",
    "tr": "Almanca ve İngilizce",
    "ru": "Немецкий и английский",
    "zh": "德语和英语",
    "fr": "Allemand et anglais",
    "es": "Alemán e inglés"
  },
  "Gruppenkurs für Anfänger": {
    "en": "Beginner group course",
    "ta": "தொடக்கநிலை குழுப் பாடநெறி",
    "si": "ආරම්භක කණ්ඩායම් පාඨමාලාව",
    "hi": "शुरुआती समूह पाठ्यक्रम",
    "ar": "دورة جماعية للمبتدئين",
    "tr": "Başlangıç grup kursu",
    "ru": "Групповой курс для начинающих",
    "zh": "初学者小组课程",
    "fr": "Cours collectif débutant",
    "es": "Curso en grupo para principiantes"
  },
  "Gruppenkurs für Grundstufe": {
    "en": "Elementary group course",
    "ta": "அடிப்படைநிலை குழுப் பாடநெறி",
    "si": "මූලික කණ්ඩායම් පාඨමාලාව",
    "hi": "प्रारंभिक समूह पाठ्यक्रम",
    "ar": "دورة جماعية للمستوى الأساسي",
    "tr": "Temel grup kursu",
    "ru": "Групповой курс начального уровня",
    "zh": "基础小组课程",
    "fr": "Cours collectif élémentaire",
    "es": "Curso en grupo básico"
  },
  "Gruppenkurs für Mittelstufe": {
    "en": "Intermediate group course",
    "ta": "இடைநிலை குழுப் பாடநெறி",
    "si": "මධ්‍යම කණ්ඩායම් පාඨමාලාව",
    "hi": "मध्यम समूह पाठ्यक्रम",
    "ar": "دورة جماعية للمستوى المتوسط",
    "tr": "Orta seviye grup kursu",
    "ru": "Групповой курс среднего уровня",
    "zh": "中级小组课程",
    "fr": "Cours collectif intermédiaire",
    "es": "Curso en grupo intermedio"
  },
  "Gruppenkurs für Oberstufe": {
    "en": "Upper-intermediate group course",
    "ta": "மேல்நிலை குழுப் பாடநெறி",
    "si": "උසස් මධ්‍යම කණ්ඩායම් පාඨමාලාව",
    "hi": "उच्च मध्यम समूह पाठ्यक्रम",
    "ar": "دورة جماعية للمستوى فوق المتوسط",
    "tr": "Üst orta grup kursu",
    "ru": "Групповой курс выше среднего",
    "zh": "中高级小组课程",
    "fr": "Cours collectif intermédiaire supérieur",
    "es": "Curso en grupo intermedio alto"
  },
  "Online-Gruppenkurs": {
    "en": "Online group course",
    "ta": "இணையவழி குழுப் பாடநெறி",
    "si": "මාර්ගගත කණ්ඩායම් පාඨමාලාව",
    "hi": "ऑनलाइन समूह पाठ्यक्रम",
    "ar": "دورة جماعية عبر الإنترنت",
    "tr": "Çevrim içi grup kursu",
    "ru": "Онлайн-групповой курс",
    "zh": "在线小组课程",
    "fr": "Cours collectif en ligne",
    "es": "Curso grupal en línea"
  },
  "Kursdauer": {
    "en": "Course duration",
    "ta": "பாடநெறிக் கால அளவு",
    "si": "පාඨමාලා කාලය",
    "hi": "पाठ्यक्रम की अवधि",
    "ar": "مدة الدورة",
    "tr": "Kurs süresi",
    "ru": "Длительность курса",
    "zh": "课程时长",
    "fr": "Durée du cours",
    "es": "Duración del curso"
  },
  "Erklärsprache": {
    "en": "Language of instruction",
    "ta": "கற்பிக்கும் மொழி",
    "si": "ඉගැන්වීමේ භාෂාව",
    "hi": "शिक्षण की भाषा",
    "ar": "لغة التدريس",
    "tr": "Eğitim dili",
    "ru": "Язык обучения",
    "zh": "授课语言",
    "fr": "Langue d’enseignement",
    "es": "Idioma de enseñanza"
  },
  "Kursinhalt": {
    "en": "Course content",
    "ta": "பாடநெறி உள்ளடக்கம்",
    "si": "පාඨමාලා අන්තර්ගතය",
    "hi": "पाठ्यक्रम सामग्री",
    "ar": "محتوى الدورة",
    "tr": "Kurs içeriği",
    "ru": "Содержание курса",
    "zh": "课程内容",
    "fr": "Contenu du cours",
    "es": "Contenido del curso"
  },
  "Kostenlos inklusive": {
    "en": "Included free",
    "ta": "இலவசமாகச் சேர்க்கப்பட்டுள்ளது",
    "si": "නොමිලේ ඇතුළත්",
    "hi": "नि:शुल्क शामिल",
    "ar": "مشمول مجانًا",
    "tr": "Ücretsiz dâhil",
    "ru": "Включено бесплатно",
    "zh": "免费包含",
    "fr": "Inclus gratuitement",
    "es": "Incluido gratis"
  },
  "10 PDF-Bücher": {
    "en": "10 PDF books",
    "ta": "10 PDF புத்தகங்கள்",
    "si": "PDF පොත් 10ක්",
    "hi": "10 PDF पुस्तकें",
    "ar": "10 كتب PDF",
    "tr": "10 PDF kitap",
    "ru": "10 книг PDF",
    "zh": "10 本 PDF 书籍",
    "fr": "10 livres PDF",
    "es": "10 libros PDF"
  },
  "PDF-Bücher inklusive": {
    "en": "PDF books included",
    "ta": "PDF புத்தகங்கள் சேர்க்கப்பட்டுள்ளன",
    "si": "PDF පොත් ඇතුළත්",
    "hi": "PDF पुस्तकें शामिल",
    "ar": "كتب PDF مشمولة",
    "tr": "PDF kitaplar dâhil",
    "ru": "Книги PDF включены",
    "zh": "包含 PDF 书籍",
    "fr": "Livres PDF inclus",
    "es": "Libros PDF incluidos"
  },
  "Klare Erklärungen": {
    "en": "Clear explanations",
    "ta": "தெளிவான விளக்கங்கள்",
    "si": "පැහැදිලි පැහැදිලි කිරීම්",
    "hi": "स्पष्ट व्याख्याएँ",
    "ar": "شروحات واضحة",
    "tr": "Anlaşılır açıklamalar",
    "ru": "Понятные объяснения",
    "zh": "清晰的讲解",
    "fr": "Explications claires",
    "es": "Explicaciones claras"
  },
  "Sicherer Zugang": {
    "en": "Secure access",
    "ta": "பாதுகாப்பான அணுகல்",
    "si": "ආරක්ෂිත ප්‍රවේශය",
    "hi": "सुरक्षित पहुँच",
    "ar": "وصول آمن",
    "tr": "Güvenli erişim",
    "ru": "Безопасный доступ",
    "zh": "安全访问",
    "fr": "Accès sécurisé",
    "es": "Acceso seguro"
  },
  "Einloggen und Kurs öffnen": {
    "en": "Sign in and open course",
    "ta": "உள்நுழைந்து பாடநெறியைத் திறக்க",
    "si": "පිවිසී පාඨමාලාව විවෘත කරන්න",
    "hi": "साइन इन करके पाठ्यक्रम खोलें",
    "ar": "سجّل الدخول وافتح الدورة",
    "tr": "Giriş yap ve kursu aç",
    "ru": "Войдите и откройте курс",
    "zh": "登录并打开课程",
    "fr": "Se connecter et ouvrir le cours",
    "es": "Inicia sesión y abre el curso"
  },
  "Bitte loggen Sie sich mit Ihrem Dear-Language-Konto ein. Danach wird Ihr vorhandener Kurszugang automatisch aus dem gemeinsamen Zugangsspeicher geladen.": {
    "en": "Please sign in with your Dear Language account. Your existing course access will then load automatically.",
    "ta": "உங்கள் Dear Language கணக்கில் உள்நுழையுங்கள். ஏற்கெனவே உள்ள பாடநெறி அணுகல் தானாக ஏற்றப்படும்.",
    "si": "Dear Language ගිණුමට පිවිසෙන්න. පවතින පාඨමාලා ප්‍රවේශය ස්වයංක්‍රීයව පූරණය වනු ඇත.",
    "hi": "Dear Language खाते में साइन इन करें। आपकी मौजूदा पाठ्यक्रम पहुँच अपने आप लोड होगी।",
    "ar": "سجّل الدخول بحساب Dear Language. سيتم تحميل وصولك الحالي إلى الدورة تلقائيًا.",
    "tr": "Dear Language hesabına giriş yap. Mevcut kurs erişimin otomatik olarak yüklenecek.",
    "ru": "Войдите в аккаунт Dear Language. Ваш действующий доступ к курсу загрузится автоматически.",
    "zh": "请登录 Dear Language 账户，系统将自动加载您已有的课程权限。",
    "fr": "Connectez-vous à votre compte Dear Language. Votre accès existant sera chargé automatiquement.",
    "es": "Inicia sesión en tu cuenta Dear Language. Tu acceso existente se cargará automáticamente."
  },
  "Bestehenden Kurszugang erkennen": {
    "en": "Recognize existing course access",
    "ta": "தற்போதைய பாடநெறி அணுகலைக் கண்டறிய",
    "si": "පවතින පාඨමාලා ප්‍රවේශය හඳුනාගන්න",
    "hi": "मौजूदा पाठ्यक्रम पहुँच पहचानें",
    "ar": "التعرّف على وصولك الحالي إلى الدورة",
    "tr": "Mevcut kurs erişimini tanı",
    "ru": "Определить существующий доступ",
    "zh": "识别现有课程权限",
    "fr": "Reconnaître l’accès existant",
    "es": "Detectar el acceso actual"
  },
  "Freigeschalteten Kurs sofort öffnen": {
    "en": "Open unlocked course immediately",
    "ta": "திறக்கப்பட்ட பாடநெறியை உடனே திறக்க",
    "si": "විවෘත පාඨමාලාව වහාම අරින්න",
    "hi": "अनलॉक पाठ्यक्रम तुरंत खोलें",
    "ar": "فتح الدورة المتاحة فورًا",
    "tr": "Açık kursu hemen aç",
    "ru": "Сразу открыть доступный курс",
    "zh": "立即打开已解锁课程",
    "fr": "Ouvrir immédiatement le cours débloqué",
    "es": "Abrir curso desbloqueado ahora"
  },
  "Sichere Anmeldung mit Firebase": {
    "en": "Secure Firebase sign-in",
    "ta": "பாதுகாப்பான Firebase உள்நுழைவு",
    "si": "ආරක්ෂිත Firebase පිවිසීම",
    "hi": "सुरक्षित Firebase साइन इन",
    "ar": "تسجيل دخول آمن عبر Firebase",
    "tr": "Güvenli Firebase girişi",
    "ru": "Безопасный вход через Firebase",
    "zh": "通过 Firebase 安全登录",
    "fr": "Connexion Firebase sécurisée",
    "es": "Inicio de sesión seguro con Firebase"
  },
  "Zahlung nur bei gesperrtem Kurs": {
    "en": "Payment only for locked courses",
    "ta": "பூட்டப்பட்ட பாடநெறிகளுக்கு மட்டும் கட்டணம்",
    "si": "අගුළු දැමූ පාඨමාලාවලට පමණක් ගෙවීම්",
    "hi": "केवल लॉक पाठ्यक्रम के लिए भुगतान",
    "ar": "الدفع للدورات المقفلة فقط",
    "tr": "Yalnızca kilitli kurslar için ödeme",
    "ru": "Оплата только для закрытого курса",
    "zh": "仅锁定课程需要付款",
    "fr": "Paiement uniquement pour les cours verrouillés",
    "es": "Pago solo para cursos bloqueados"
  },
  "Niveau": {
    "en": "Level",
    "ta": "நிலை",
    "si": "මට්ටම",
    "hi": "स्तर",
    "ar": "المستوى",
    "tr": "Seviye",
    "ru": "Уровень",
    "zh": "级别",
    "fr": "Niveau",
    "es": "Nivel"
  },
  "Status": {
    "en": "Status",
    "ta": "நிலைமை",
    "si": "තත්ත්වය",
    "hi": "स्थिति",
    "ar": "الحالة",
    "tr": "Durum",
    "ru": "Статус",
    "zh": "状态",
    "fr": "Statut",
    "es": "Estado"
  },
  "Nach dem Einloggen wird kein zusätzlicher Kurszugang geprüft, wenn der gemeinsame AuthContext-Cache noch aktuell ist.": {
    "en": "After sign-in, access is not rechecked if the shared cache is still current.",
    "ta": "பகிரப்பட்ட தற்காலிகத் தரவு புதுப்பிக்கப்பட்டிருந்தால், உள்நுழைந்த பிறகு அணுகல் மீண்டும் சரிபார்க்கப்படாது.",
    "si": "පොදු හැඹිලිය යාවත්කාලීන නම් පිවිසීමෙන් පසු ප්‍රවේශය නැවත පරීක්ෂා නොකෙරේ.",
    "hi": "यदि साझा कैश अभी मान्य है तो साइन इन के बाद पहुँच फिर नहीं जाँची जाएगी।",
    "ar": "لا يُعاد فحص الوصول بعد تسجيل الدخول إذا كانت البيانات المؤقتة المشتركة حديثة.",
    "tr": "Ortak önbellek güncelse girişten sonra erişim tekrar kontrol edilmez.",
    "ru": "Если общий кэш актуален, доступ после входа повторно не проверяется.",
    "zh": "如果共享缓存仍有效，登录后不会重新核验权限。",
    "fr": "Après connexion, l’accès n’est pas revérifié si le cache partagé est à jour.",
    "es": "Tras iniciar sesión no se vuelve a comprobar el acceso si la caché compartida sigue vigente."
  },
  "Kurszugang wird aktualisiert": {
    "en": "Updating course access",
    "ta": "பாடநெறி அணுகல் புதுப்பிக்கப்படுகிறது",
    "si": "පාඨමාලා ප්‍රවේශය යාවත්කාලීන වේ",
    "hi": "पाठ्यक्रम पहुँच अपडेट हो रही है",
    "ar": "جارٍ تحديث وصول الدورة",
    "tr": "Kurs erişimi güncelleniyor",
    "ru": "Обновляется доступ к курсу",
    "zh": "正在更新课程权限",
    "fr": "Mise à jour de l’accès au cours",
    "es": "Actualizando acceso al curso"
  },
  "Bitte warten Sie kurz. Der Zugang wird nach der Zahlung oder der manuellen Aktualisierung bestätigt.": {
    "en": "Please wait. Access will be confirmed after payment or manual refresh.",
    "ta": "சற்று காத்திருக்கவும். கட்டணத்திற்குப் பிறகு அல்லது கைமுறைப் புதுப்பிப்புக்குப் பிறகு அணுகல் உறுதிசெய்யப்படும்.",
    "si": "රැඳී සිටින්න. ගෙවීමෙන් හෝ අතින් යාවත්කාලීන කිරීමෙන් පසු ප්‍රවේශය තහවුරු කෙරේ.",
    "hi": "कृपया प्रतीक्षा करें। भुगतान या मैनुअल अपडेट के बाद पहुँच की पुष्टि होगी।",
    "ar": "يرجى الانتظار. سيُؤكد الوصول بعد الدفع أو التحديث اليدوي.",
    "tr": "Lütfen bekle. Ödemeden veya elle yenilemeden sonra erişim onaylanacak.",
    "ru": "Подождите. Доступ подтвердится после оплаты или ручного обновления.",
    "zh": "请稍候。付款或手动刷新后将确认权限。",
    "fr": "Veuillez patienter. L’accès sera confirmé après paiement ou actualisation manuelle.",
    "es": "Espera. El acceso se confirmará tras el pago o la actualización manual."
  },
  "Kurszugang wird geprüft": {
    "en": "Checking course access",
    "ta": "பாடநெறி அணுகல் சரிபார்க்கப்படுகிறது",
    "si": "පාඨමාලා ප්‍රවේශය පරීක්ෂා කෙරේ",
    "hi": "पाठ्यक्रम पहुँच जाँची जा रही है",
    "ar": "جارٍ التحقق من وصول الدورة",
    "tr": "Kurs erişimi kontrol ediliyor",
    "ru": "Проверяется доступ к курсу",
    "zh": "正在核验课程权限",
    "fr": "Vérification de l’accès au cours",
    "es": "Comprobando acceso al curso"
  },
  "Sichere Prüfung über Ihr Konto": {
    "en": "Secure check through your account",
    "ta": "உங்கள் கணக்கின் மூலம் பாதுகாப்பான சரிபார்ப்பு",
    "si": "ඔබේ ගිණුමෙන් ආරක්ෂිත පරීක්ෂාව",
    "hi": "आपके खाते से सुरक्षित जाँच",
    "ar": "تحقق آمن عبر حسابك",
    "tr": "Hesabın üzerinden güvenli kontrol",
    "ru": "Безопасная проверка через аккаунт",
    "zh": "通过账户进行安全核验",
    "fr": "Vérification sécurisée via votre compte",
    "es": "Comprobación segura con tu cuenta"
  },
  "Beim normalen Öffnen der Kursseite wird dieser Vorgang nicht erneut gestartet.": {
    "en": "This check is not repeated when opening the course page normally.",
    "ta": "பாடநெறிப் பக்கத்தை வழக்கமாகத் திறக்கும்போது இந்தச் சரிபார்ப்பு மீண்டும் தொடங்காது.",
    "si": "සාමාන්‍යයෙන් පාඨමාලා පිටුව විවෘත කිරීමේදී මෙය නැවත ආරම්භ නොවේ.",
    "hi": "सामान्य रूप से पाठ्यक्रम पेज खोलने पर यह प्रक्रिया दोबारा शुरू नहीं होती।",
    "ar": "لا يتكرر هذا الفحص عند فتح صفحة الدورة بشكل طبيعي.",
    "tr": "Kurs sayfası normal açılırken bu işlem tekrarlanmaz.",
    "ru": "При обычном открытии курса проверка не запускается повторно.",
    "zh": "正常打开课程页面时不会重复此操作。",
    "fr": "Ce contrôle ne se répète pas à l’ouverture habituelle du cours.",
    "es": "Esta comprobación no se repite al abrir normalmente la página del curso."
  },
  "Deutsch Akademie": {
    "en": "German Academy",
    "ta": "ஜெர்மன் அகாடமி",
    "si": "ජර්මන් ඇකඩමිය",
    "hi": "जर्मन अकादमी",
    "ar": "أكاديمية الألمانية",
    "tr": "Almanca Akademisi",
    "ru": "Академия немецкого",
    "zh": "德语学院",
    "fr": "Académie allemande",
    "es": "Academia de alemán"
  },
  "Zugang wird im Hintergrund aktualisiert...": {
    "en": "Updating access in the background...",
    "ta": "பின்னணியில் அணுகல் புதுப்பிக்கப்படுகிறது...",
    "si": "පසුබිමේ ප්‍රවේශය යාවත්කාලීන වේ...",
    "hi": "पृष्ठभूमि में पहुँच अपडेट हो रही है...",
    "ar": "جارٍ تحديث الوصول في الخلفية...",
    "tr": "Erişim arka planda güncelleniyor...",
    "ru": "Доступ обновляется в фоне...",
    "zh": "正在后台更新权限...",
    "fr": "Actualisation de l’accès en arrière-plan...",
    "es": "Actualizando acceso en segundo plano..."
  },
  "Deutsch": {
    "en": "German",
    "ta": "ஜெர்மன்",
    "si": "ජර්මන්",
    "hi": "जर्मन",
    "ar": "الألمانية",
    "tr": "Almanca",
    "ru": "Немецкий",
    "zh": "德语",
    "fr": "Allemand",
    "es": "Alemán"
  },
  "Bonus": {
    "en": "Bonus",
    "ta": "கூடுதல் சலுகை",
    "si": "ප්‍රසාදය",
    "hi": "बोनस",
    "ar": "مكافأة إضافية",
    "tr": "Bonus",
    "ru": "Бонус",
    "zh": "额外福利",
    "fr": "Bonus",
    "es": "Bono"
  },
  "Welche Kursniveaus gibt es auf der Website?": {
    "en": "Which course levels are available on the website?",
    "ta": "இணையதளத்தில் எந்தப் பாடநெறி நிலைகள் உள்ளன?",
    "si": "වෙබ් අඩවියේ ඇති පාඨමාලා මට්ටම් මොනවාද?",
    "hi": "वेबसाइट पर कौन-से पाठ्यक्रम स्तर हैं?",
    "ar": "ما مستويات الدورات المتاحة على الموقع؟",
    "tr": "Web sitesinde hangi kurs seviyeleri var?",
    "ru": "Какие уровни курсов есть на сайте?",
    "zh": "网站提供哪些课程级别？",
    "fr": "Quels niveaux de cours sont proposés ?",
    "es": "¿Qué niveles de curso hay en la web?"
  },
  "Wie lange dauert ein Deutschkurs?": {
    "en": "How long does a German course last?",
    "ta": "ஒரு ஜெர்மன் பாடநெறி எவ்வளவு காலம் நீடிக்கும்?",
    "si": "ජර්මන් පාඨමාලාවක් කොපමණ කාලයක්ද?",
    "hi": "जर्मन पाठ्यक्रम कितने समय का होता है?",
    "ar": "ما مدة دورة اللغة الألمانية؟",
    "tr": "Almanca kursu ne kadar sürer?",
    "ru": "Сколько длится курс немецкого?",
    "zh": "德语课程持续多久？",
    "fr": "Combien de temps dure un cours d’allemand ?",
    "es": "¿Cuánto dura un curso de alemán?"
  },
  "Wie viele Bücher gibt es?": {
    "en": "How many books are there?",
    "ta": "எத்தனை புத்தகங்கள் உள்ளன?",
    "si": "පොත් කීයක් තිබේද?",
    "hi": "कितनी पुस्तकें हैं?",
    "ar": "كم عدد الكتب؟",
    "tr": "Kaç kitap var?",
    "ru": "Сколько всего книг?",
    "zh": "一共有多少本书？",
    "fr": "Combien y a-t-il de livres ?",
    "es": "¿Cuántos libros hay?"
  },
  "Sind alle Bücher automatisch kostenlos?": {
    "en": "Are all books automatically free?",
    "ta": "எல்லாப் புத்தகங்களும் தானாக இலவசமா?",
    "si": "සියලු පොත් ස්වයංක්‍රීයව නොමිලේද?",
    "hi": "क्या सभी पुस्तकें अपने आप निःशुल्क हैं?",
    "ar": "هل كل الكتب مجانية تلقائيًا؟",
    "tr": "Bütün kitaplar otomatik olarak ücretsiz mi?",
    "ru": "Все книги автоматически бесплатны?",
    "zh": "所有图书都会自动免费吗？",
    "fr": "Tous les livres sont-ils automatiquement gratuits ?",
    "es": "¿Todos los libros son gratuitos automáticamente?"
  },
  "In welchen Sprachen gibt es Übersetzungen?": {
    "en": "Which translation languages are available?",
    "ta": "எந்த மொழிகளில் மொழிபெயர்ப்புகள் உள்ளன?",
    "si": "පරිවර්තන ඇති භාෂා මොනවාද?",
    "hi": "अनुवाद किन भाषाओं में उपलब्ध हैं?",
    "ar": "ما لغات الترجمة المتاحة؟",
    "tr": "Hangi dillerde çeviri var?",
    "ru": "На какие языки есть переводы?",
    "zh": "提供哪些翻译语言？",
    "fr": "Quelles langues de traduction sont disponibles ?",
    "es": "¿En qué idiomas hay traducciones?"
  },
  "Kann ich auch auf dem Smartphone lernen?": {
    "en": "Can I learn on my smartphone too?",
    "ta": "மொபைலிலும் கற்க முடியுமா?",
    "si": "දුරකථනයෙන්ද ඉගෙන ගත හැකිද?",
    "hi": "क्या मैं स्मार्टफ़ोन पर भी सीख सकता हूँ?",
    "ar": "هل يمكنني التعلّم على الهاتف أيضًا؟",
    "tr": "Akıllı telefonumdan da öğrenebilir miyim?",
    "ru": "Можно ли учиться со смартфона?",
    "zh": "可以在手机上学习吗？",
    "fr": "Puis-je aussi apprendre sur smartphone ?",
    "es": "¿Puedo aprender también desde el móvil?"
  },
  "Die Kursübersicht enthält A1, A2, B1 und B2. Die Bücherbibliothek ist nach den Niveaus A1 bis C2 gegliedert.": {
    "en": "The course overview includes A1, A2, B1 and B2. The book library is organized from A1 to C2.",
    "ta": "பாடநெறிகளில் A1, A2, B1, B2 நிலைகள் உள்ளன. புத்தக நூலகம் A1 முதல் C2 வரை அமைக்கப்பட்டுள்ளது.",
    "si": "පාඨමාලා සාරාංශයේ A1, A2, B1 සහ B2 ඇත. පොත් පුස්තකාලය A1 සිට C2 දක්වා සකසා ඇත.",
    "hi": "पाठ्यक्रम में A1, A2, B1 और B2 हैं। पुस्तकालय A1 से C2 तक व्यवस्थित है।",
    "ar": "تتضمن الدورات المستويات A1 وA2 وB1 وB2. وتُنظّم مكتبة الكتب من A1 إلى C2.",
    "tr": "Kurslar A1, A2, B1 ve B2 seviyelerini içerir. Kitap kütüphanesi A1'den C2'ye düzenlenmiştir.",
    "ru": "Курсы охватывают A1, A2, B1 и B2. Библиотека организована от A1 до C2.",
    "zh": "课程包括 A1、A2、B1 和 B2。图书馆按 A1 至 C2 级别分类。",
    "fr": "Les cours couvrent A1, A2, B1 et B2. La bibliothèque est classée de A1 à C2.",
    "es": "Los cursos incluyen A1, A2, B1 y B2. La biblioteca está organizada de A1 a C2."
  },
  "Laut Kursübersicht dauern A1 und A2 jeweils zwei Monate, B1 und B2 jeweils drei Monate. Die aktuellen Einzelheiten findest du auf der Kursseite.": {
    "en": "A1 and A2 each last two months, while B1 and B2 each last three months. Visit the course page for current details.",
    "ta": "A1 மற்றும் A2 தலா இரண்டு மாதங்களும் B1 மற்றும் B2 தலா மூன்று மாதங்களும் நீடிக்கும். தற்போதைய விவரங்களைப் பாடநெறிப் பக்கத்தில் காணலாம்.",
    "si": "A1 හා A2 මාස දෙක බැගින්ද B1 හා B2 මාස තුන බැගින්ද පවතී. නවතම විස්තර පාඨමාලා පිටුවේ බලන්න.",
    "hi": "A1 और A2 दो-दो महीने और B1 और B2 तीन-तीन महीने के हैं। ताज़ा जानकारी पाठ्यक्रम पृष्ठ पर देखें।",
    "ar": "تستمر A1 وA2 شهرين لكل منهما، وB1 وB2 ثلاثة أشهر لكل منهما. راجع صفحة الدورات للتفاصيل الحالية.",
    "tr": "A1 ve A2 ikişer ay, B1 ve B2 üçer ay sürer. Güncel bilgileri kurs sayfasında bulabilirsin.",
    "ru": "A1 и A2 длятся по два месяца, B1 и B2 — по три. Актуальные сведения — на странице курсов.",
    "zh": "A1 和 A2 各持续两个月，B1 和 B2 各持续三个月。请查看课程页面了解最新信息。",
    "fr": "A1 et A2 durent deux mois chacun ; B1 et B2 trois mois chacun. Consultez la page des cours pour les détails actuels.",
    "es": "A1 y A2 duran dos meses cada uno, y B1 y B2 tres meses cada uno. Consulta la página del curso para ver los datos actuales."
  },
  "Die Bibliothek umfasst insgesamt 60 Bücher: zehn Bücher pro Niveau von A1 bis C2. Der Zugriff hängt von deinen bestehenden Freischaltungen ab.": {
    "en": "The library contains 60 books: ten at each level from A1 to C2. Access depends on your unlocked content.",
    "ta": "நூலகத்தில் மொத்தம் 60 புத்தகங்கள் உள்ளன: A1 முதல் C2 வரை ஒவ்வொரு நிலைக்கும் பத்து புத்தகங்கள். அணுகல் உங்கள் அனுமதிகளைப் பொறுத்தது.",
    "si": "පුස්තකාලයේ පොත් 60ක් තිබේ: A1 සිට C2 දක්වා සෑම මට්ටමකටම දහය බැගින්. ප්‍රවේශය ඔබට විවෘත කළ අන්තර්ගතය අනුව වෙනස් වේ.",
    "hi": "पुस्तकालय में 60 पुस्तकें हैं: A1 से C2 तक हर स्तर पर दस। पहुँच आपके अनलॉक किए गए स्तरों पर निर्भर करती है।",
    "ar": "تحتوي المكتبة على 60 كتابًا: عشرة لكل مستوى من A1 إلى C2. يعتمد الوصول على ما فُتح في حسابك.",
    "tr": "Kütüphanede 60 kitap var: A1'den C2'ye her seviyede on kitap. Erişim, açılmış içeriklerine bağlıdır.",
    "ru": "В библиотеке 60 книг: по десять на каждом уровне от A1 до C2. Доступ зависит от открытых материалов.",
    "zh": "图书馆共有 60 本书：A1 至 C2 每级 10 本。访问权限取决于您已解锁的内容。",
    "fr": "La bibliothèque comprend 60 livres : dix par niveau de A1 à C2. L’accès dépend de vos déblocages.",
    "es": "La biblioteca tiene 60 libros: diez por cada nivel de A1 a C2. El acceso depende de los contenidos desbloqueados."
  },
  "Nein. Freigeschaltete Bücher können mit dem passenden Konto geöffnet werden. Für weitere Bücher ist der jeweils angebotene Zugang erforderlich.": {
    "en": "No. You can open unlocked books with the right account. Additional books require the corresponding access.",
    "ta": "இல்லை. அணுகல் உள்ள புத்தகங்களைப் பொருத்தமான கணக்கில் திறக்கலாம். மற்ற புத்தகங்களுக்கு உரிய அனுமதி தேவை.",
    "si": "නැත. විවෘත පොත් සුදුසු ගිණුමකින් බැලිය හැක. වෙනත් පොත් සඳහා අදාළ ප්‍රවේශය අවශ්‍යයි.",
    "hi": "नहीं। सही खाते से अनलॉक पुस्तकें खोली जा सकती हैं। बाकी पुस्तकों के लिए संबंधित पहुँच ज़रूरी है।",
    "ar": "لا. يمكن فتح الكتب المتاحة بالحساب المناسب. تتطلب الكتب الأخرى صلاحية الوصول المقابلة.",
    "tr": "Hayır. Erişime açık kitapları uygun hesapla açabilirsin. Diğerleri için ilgili erişim gerekir.",
    "ru": "Нет. Доступные книги можно открывать с подходящим аккаунтом. Для других требуется соответствующий доступ.",
    "zh": "不是。可用相应账户打开已解锁图书。其他图书需要对应权限。",
    "fr": "Non. Les livres débloqués peuvent être ouverts avec le compte approprié. D’autres livres requièrent l’accès correspondant.",
    "es": "No. Los libros desbloqueados se pueden abrir con la cuenta adecuada. Los demás necesitan el acceso correspondiente."
  },
  "Für das Wort des Tages stehen die unterstützten Übersetzungssprachen im Sprachmenü zur Auswahl. Die Unterrichtssprache eines Kurses steht in den jeweiligen Kursdetails.": {
    "en": "The Word of the Day supports the translation languages listed in the language menu. The language of instruction appears in each course's details.",
    "ta": "இன்றைய சொல்லுக்கான மொழிபெயர்ப்பு மொழிகள் மொழிப் பட்டியலில் உள்ளன. பாடநெறியின் கற்பிக்கும் மொழி அதன் விவரங்களில் குறிப்பிடப்பட்டுள்ளது.",
    "si": "දවසේ වචනය සඳහා භාෂා ලැයිස්තුවේ ඇති පරිවර්තන භාෂා භාවිත කළ හැක. ඉගැන්වීමේ භාෂාව පාඨමාලා විස්තරවල ඇත.",
    "hi": "आज के शब्द के लिए भाषा मेनू में उपलब्ध अनुवाद भाषाएँ चुनी जा सकती हैं। पाठ्यक्रम की शिक्षण भाषा उसके विवरण में है।",
    "ar": "لغات ترجمة كلمة اليوم موجودة في قائمة اللغة. وتظهر لغة التدريس في تفاصيل كل دورة.",
    "tr": "Günün kelimesi için dil menüsündeki çeviri dillerini seçebilirsin. Kursun öğretim dili, kurs ayrıntılarında yer alır.",
    "ru": "Для слова дня доступны языки из меню. Язык преподавания указан в описании каждого курса.",
    "zh": "每日单词可选择语言菜单中的翻译语言。授课语言见相应课程详情。",
    "fr": "Le mot du jour utilise les langues de traduction du menu. La langue d’enseignement figure dans les détails du cours.",
    "es": "La palabra del día admite los idiomas de traducción del menú. El idioma de enseñanza figura en los detalles del curso."
  },
  "Ja. Über die offiziellen Store-Links gelangst du zur GERMAN A1-C2 App für iOS oder Android.": {
    "en": "Yes. The official store links take you to the GERMAN A1-C2 app for iOS or Android.",
    "ta": "ஆம். அதிகாரப்பூர்வ செயலிக் கடை இணைப்புகள் மூலம் iOS அல்லது Android-க்கான GERMAN A1-C2 செயலியைப் பெறலாம்.",
    "si": "ඔව්. නිල වෙළඳසැල් සබැඳි මඟින් iOS හෝ Android සඳහා GERMAN A1-C2 යෙදුම ලබාගත හැක.",
    "hi": "हाँ। आधिकारिक स्टोर लिंक से iOS या Android के लिए GERMAN A1-C2 ऐप पा सकते हैं।",
    "ar": "نعم. تقودك روابط المتاجر الرسمية إلى تطبيق GERMAN A1-C2 لنظامي iOS وAndroid.",
    "tr": "Evet. Resmî mağaza bağlantılarından iOS veya Android için GERMAN A1-C2 uygulamasına ulaşabilirsin.",
    "ru": "Да. По ссылкам на официальные магазины можно установить GERMAN A1-C2 для iOS или Android.",
    "zh": "可以。通过官方商店链接即可获取适用于 iOS 或 Android 的 GERMAN A1-C2 应用。",
    "fr": "Oui. Les liens officiels donnent accès à GERMAN A1-C2 pour iOS et Android.",
    "es": "Sí. Los enlaces oficiales llevan a la app GERMAN A1-C2 para iOS o Android."
  },
  "Premium-Zugang wird geprüft": {
    "en": "Checking Premium access",
    "ta": "பிரீமியம் அணுகல் சரிபார்க்கப்படுகிறது",
    "si": "ප්‍රිමියම් ප්‍රවේශය පරීක්ෂා කෙරේ",
    "hi": "प्रीमियम पहुँच जाँची जा रही है",
    "ar": "جارٍ التحقق من الوصول المميز",
    "tr": "Premium erişim kontrol ediliyor",
    "ru": "Проверка Премиум-доступа",
    "zh": "正在核验高级会员权限",
    "fr": "Vérification de l’accès Premium",
    "es": "Comprobando acceso prémium"
  },
  "Bitte warten Sie kurz. Ihr Konto wird sicher geprüft.": {
    "en": "Please wait while your account is checked securely.",
    "ta": "உங்கள் கணக்கு பாதுகாப்பாகச் சரிபார்க்கப்படும் வரை சற்று காத்திருக்கவும்.",
    "si": "ඔබේ ගිණුම ආරක්ෂිතව පරීක්ෂා කරන තුරු රැඳී සිටින්න.",
    "hi": "कृपया प्रतीक्षा करें, आपके खाते की सुरक्षित जाँच हो रही है।",
    "ar": "يرجى الانتظار حتى يتم التحقق من حسابك بأمان.",
    "tr": "Hesabın güvenli şekilde kontrol edilirken lütfen bekle.",
    "ru": "Подождите, идёт безопасная проверка аккаунта.",
    "zh": "请稍候，系统正在安全地核验您的账户。",
    "fr": "Veuillez patienter pendant la vérification sécurisée de votre compte.",
    "es": "Espera mientras comprobamos tu cuenta de forma segura."
  },
  "Monatsabo abschließen": {
    "en": "Start monthly subscription",
    "ta": "மாதாந்திரச் சந்தாவைத் தொடங்க",
    "si": "මාසික දායකත්වය ආරම්භ කරන්න",
    "hi": "मासिक सदस्यता शुरू करें",
    "ar": "بدء الاشتراك الشهري",
    "tr": "Aylık abonelik başlat",
    "ru": "Оформить месячную подписку",
    "zh": "开通月度订阅",
    "fr": "Souscrire un abonnement mensuel",
    "es": "Contratar suscripción mensual"
  },
  "Schalten Sie alle Deutschbücher von A1 bis C2 frei. Weitere Premium-Inhalte der Webseite werden ebenfalls über dieses Abo freigeschaltet.": {
    "en": "Unlock all German books from A1 to C2. Other website Premium content is also included in this subscription.",
    "ta": "A1 முதல் C2 வரையிலான அனைத்து ஜெர்மன் புத்தகங்களையும் திறக்கலாம். இணையதளத்தின் மற்ற பிரீமியம் உள்ளடக்கங்களும் இந்தச் சந்தாவில் அடங்கும்.",
    "si": "A1 සිට C2 දක්වා සියලුම ජර්මන් පොත් විවෘත කරන්න. වෙනත් වෙබ් ප්‍රිමියම් අන්තර්ගතයද ඇතුළත්ය.",
    "hi": "A1 से C2 तक सभी जर्मन पुस्तकें अनलॉक करें। अन्य वेबसाइट प्रीमियम सामग्री भी शामिल है।",
    "ar": "افتح جميع كتب الألمانية من A1 إلى C2. يشمل الاشتراك أيضًا المحتوى المميز الآخر بالموقع.",
    "tr": "A1'den C2'ye tüm Almanca kitapları aç. Diğer web Premium içerikleri de aboneliğe dâhildir.",
    "ru": "Откройте все книги по немецкому от A1 до C2. Другой Премиум-контент сайта также включён.",
    "zh": "解锁 A1 至 C2 的全部德语图书。订阅还包含网站上的其他高级会员内容。",
    "fr": "Débloquez tous les livres d’allemand de A1 à C2. Les autres contenus Premium du site sont également inclus.",
    "es": "Desbloquea todos los libros de alemán de A1 a C2. También incluye otros contenidos prémium de la web."
  },
  "60 PDF-Bücher": {
    "en": "60 PDF books",
    "ta": "60 PDF புத்தகங்கள்",
    "si": "PDF පොත් 60ක්",
    "hi": "60 PDF पुस्तकें",
    "ar": "60 كتاب PDF",
    "tr": "60 PDF kitap",
    "ru": "60 книг PDF",
    "zh": "60 本 PDF 图书",
    "fr": "60 livres PDF",
    "es": "60 libros PDF"
  },
  "Alle Stufen A1 bis C2": {
    "en": "All levels A1 to C2",
    "ta": "A1 முதல் C2 வரை எல்லா நிலைகளும்",
    "si": "A1 සිට C2 දක්වා සියලු මට්ටම්",
    "hi": "A1 से C2 तक सभी स्तर",
    "ar": "جميع المستويات من A1 إلى C2",
    "tr": "A1'den C2'ye tüm seviyeler",
    "ru": "Все уровни от A1 до C2",
    "zh": "A1 至 C2 全部级别",
    "fr": "Tous les niveaux de A1 à C2",
    "es": "Todos los niveles de A1 a C2"
  },
  "Premium-Inhalte inklusive": {
    "en": "Premium content included",
    "ta": "பிரீமியம் உள்ளடக்கமும் சேர்க்கப்பட்டுள்ளது",
    "si": "ප්‍රිමියම් අන්තර්ගතය ඇතුළත්",
    "hi": "प्रीमियम सामग्री शामिल",
    "ar": "المحتوى المميز مشمول",
    "tr": "Premium içerik dâhil",
    "ru": "Премиум-контент включён",
    "zh": "包含高级会员内容",
    "fr": "Contenu Premium inclus",
    "es": "Contenido prémium incluido"
  },
  "Laufzeit": {
    "en": "Billing period",
    "ta": "சந்தா காலம்",
    "si": "කාලසීමාව",
    "hi": "अवधि",
    "ar": "مدة الاشتراك",
    "tr": "Abonelik süresi",
    "ru": "Период подписки",
    "zh": "订阅周期",
    "fr": "Période",
    "es": "Período"
  },
  "Monatsabo starten": {
    "en": "Start monthly subscription",
    "ta": "மாதாந்திரச் சந்தாவைத் தொடங்க",
    "si": "මාසික දායකත්වය ආරම්භ කරන්න",
    "hi": "मासिक सदस्यता शुरू करें",
    "ar": "بدء الاشتراك الشهري",
    "tr": "Aylık aboneliği başlat",
    "ru": "Оформить месячную подписку",
    "zh": "开通月度订阅",
    "fr": "Souscrire l’abonnement mensuel",
    "es": "Iniciar suscripción mensual"
  },
  "Zahlung wird geöffnet...": {
    "en": "Opening payment...",
    "ta": "கட்டணப் பக்கம் திறக்கப்படுகிறது...",
    "si": "ගෙවීම් පිටුව විවෘත වේ...",
    "hi": "भुगतान खोला जा रहा है...",
    "ar": "جارٍ فتح الدفع...",
    "tr": "Ödeme açılıyor...",
    "ru": "Открывается оплата...",
    "zh": "正在打开支付页面...",
    "fr": "Ouverture du paiement...",
    "es": "Abriendo pago..."
  },
  "Zugang wird geprüft...": {
    "en": "Checking access...",
    "ta": "அணுகல் சரிபார்க்கப்படுகிறது...",
    "si": "ප්‍රවේශය පරීක්ෂා වේ...",
    "hi": "पहुँच जाँची जा रही है...",
    "ar": "جارٍ التحقق من الوصول...",
    "tr": "Erişim kontrol ediliyor...",
    "ru": "Проверяется доступ...",
    "zh": "正在核验权限...",
    "fr": "Vérification de l’accès...",
    "es": "Comprobando acceso..."
  },
  "Mit einem Konto wird Ihr Zugang sicher gespeichert.": {
    "en": "Your access is saved securely with an account.",
    "ta": "உங்கள் கணக்கில் அணுகல் அனுமதி பாதுகாப்பாகச் சேமிக்கப்படும்.",
    "si": "ඔබේ ප්‍රවේශය ගිණුම තුළ ආරක්ෂිතව සුරැකේ.",
    "hi": "आपकी पहुँच आपके खाते में सुरक्षित रूप से सहेजी जाती है।",
    "ar": "يتم حفظ وصولك بأمان في حسابك.",
    "tr": "Erişimin hesabında güvenli şekilde saklanır.",
    "ru": "Ваш доступ надёжно сохраняется в аккаунте.",
    "zh": "您的权限将安全地保存在账户中。",
    "fr": "Votre accès est enregistré en toute sécurité dans votre compte.",
    "es": "Tu acceso se guarda de forma segura en tu cuenta."
  },
  "Für Kurse, Bücher und weitere Inhalte müssen Sie sich zuerst einloggen. Wenn Sie noch kein Konto haben, registrieren Sie sich bitte mit einer echten E-Mail-Adresse.": {
    "en": "Sign in to use courses, books and other content. If you don't have an account, register with a real email address.",
    "ta": "பாடநெறிகள், புத்தகங்கள் உள்ளிட்ட உள்ளடக்கங்களைப் பயன்படுத்த உள்நுழைய வேண்டும். கணக்கு இல்லாவிட்டால் உண்மையான மின்னஞ்சல் முகவரியுடன் பதிவு செய்யுங்கள்.",
    "si": "පාඨමාලා, පොත් සහ වෙනත් අන්තර්ගතය සඳහා පිවිසෙන්න. ගිණුමක් නැත්නම් සැබෑ ඊමේල් ලිපිනයකින් ලියාපදිංචි වන්න.",
    "hi": "पाठ्यक्रम, पुस्तकों और अन्य सामग्री के लिए साइन इन करें। खाता न हो तो वास्तविक ईमेल से पंजीकरण करें।",
    "ar": "سجّل الدخول لاستخدام الدورات والكتب والمحتوى الآخر. إذا لم يكن لديك حساب فأنشئ حسابًا ببريد إلكتروني حقيقي.",
    "tr": "Kurslar, kitaplar ve diğer içerikler için giriş yap. Hesabın yoksa gerçek e-posta adresinle kayıt ol.",
    "ru": "Войдите для курсов, книг и другого контента. Если аккаунта нет, зарегистрируйтесь с действующим адресом почты.",
    "zh": "请登录后使用课程、图书和其他内容。没有账户请使用真实邮箱注册。",
    "fr": "Connectez-vous pour accéder aux cours, livres et autres contenus. Sans compte, inscrivez-vous avec une véritable adresse e-mail.",
    "es": "Inicia sesión para usar cursos, libros y demás contenidos. Si no tienes cuenta, regístrate con un correo real."
  },
  "E-Mail-Adresse": {
    "en": "Email address",
    "ta": "மின்னஞ்சல் முகவரி",
    "si": "ඊමේල් ලිපිනය",
    "hi": "ईमेल पता",
    "ar": "عنوان البريد الإلكتروني",
    "tr": "E-posta adresi",
    "ru": "Адрес эл. почты",
    "zh": "电子邮箱地址",
    "fr": "Adresse e-mail",
    "es": "Dirección de correo"
  },
  "Passwort": {
    "en": "Password",
    "ta": "கடவுச்சொல்",
    "si": "මුරපදය",
    "hi": "पासवर्ड",
    "ar": "كلمة المرور",
    "tr": "Şifre",
    "ru": "Пароль",
    "zh": "密码",
    "fr": "Mot de passe",
    "es": "Contraseña"
  },
  "Passwort merken": {
    "en": "Remember password",
    "ta": "கடவுச்சொல்லை நினைவில் வைத்துக்கொள்ள",
    "si": "මුරපදය මතක තබාගන්න",
    "hi": "पासवर्ड याद रखें",
    "ar": "تذكر كلمة المرور",
    "tr": "Şifreyi hatırla",
    "ru": "Запомнить пароль",
    "zh": "记住密码",
    "fr": "Mémoriser le mot de passe",
    "es": "Recordar contraseña"
  },
  "Kaufen Sie den Kurszugang sicher über unser geschütztes Zahlungssystem.": {
    "en": "Purchase course access securely through our protected payment system.",
    "ta": "எங்கள் பாதுகாப்பான கட்டண முறையின் மூலம் பாடநெறி அணுகலை வாங்குங்கள்.",
    "si": "අපගේ ආරක්ෂිත ගෙවීම් පද්ධතියෙන් පාඨමාලා ප්‍රවේශය මිලදී ගන්න.",
    "hi": "हमारी सुरक्षित भुगतान प्रणाली से पाठ्यक्रम की पहुँच खरीदें।",
    "ar": "اشترِ الوصول إلى الدورة بأمان عبر نظام الدفع المحمي لدينا.",
    "tr": "Kurs erişimini korumalı ödeme sistemimizden güvenle satın al.",
    "ru": "Купите доступ через защищённую платёжную систему.",
    "zh": "通过我们的安全付款系统购买课程权限。",
    "fr": "Achetez l’accès via notre système de paiement sécurisé.",
    "es": "Compra el acceso de forma segura mediante nuestro sistema de pago protegido."
  },
  "1 Jahr Kurszugang": {
    "en": "1 year of course access",
    "ta": "ஓராண்டு பாடநெறி அணுகல்",
    "si": "වසරක පාඨමාලා ප්‍රවේශය",
    "hi": "एक साल की पाठ्यक्रम पहुँच",
    "ar": "سنة من الوصول إلى الدورة",
    "tr": "1 yıllık kurs erişimi",
    "ru": "Доступ к курсу на 1 год",
    "zh": "1 年课程权限",
    "fr": "1 an d’accès au cours",
    "es": "1 año de acceso al curso"
  },
  "10 PDF-Bücher inklusive": {
    "en": "10 PDF books included",
    "ta": "10 PDF புத்தகங்கள் சேர்க்கப்பட்டுள்ளன",
    "si": "PDF පොත් 10ක් ඇතුළත්",
    "hi": "10 PDF पुस्तकें शामिल",
    "ar": "10 كتب PDF مشمولة",
    "tr": "10 PDF kitap dâhil",
    "ru": "10 книг PDF включены",
    "zh": "包含 10 本 PDF 图书",
    "fr": "10 livres PDF inclus",
    "es": "10 libros PDF incluidos"
  },
  "Premium-App inklusive": {
    "en": "Premium app included",
    "ta": "பிரீமியம் செயலியும் சேர்க்கப்பட்டுள்ளது",
    "si": "ප්‍රිමියම් යෙදුම ඇතුළත්",
    "hi": "प्रीमियम ऐप शामिल",
    "ar": "التطبيق المميز مشمول",
    "tr": "Premium uygulama dâhil",
    "ru": "Премиум-приложение включено",
    "zh": "包含高级会员应用",
    "fr": "Application Premium incluse",
    "es": "Aplicación prémium incluida"
  },
  "Zahlungsmethode": {
    "en": "Payment method",
    "ta": "கட்டண முறை",
    "si": "ගෙවීම් ක්‍රමය",
    "hi": "भुगतान विधि",
    "ar": "طريقة الدفع",
    "tr": "Ödeme yöntemi",
    "ru": "Способ оплаты",
    "zh": "付款方式",
    "fr": "Mode de paiement",
    "es": "Método de pago"
  },
  "Standard: Karte": {
    "en": "Default: Card",
    "ta": "இயல்புநிலை: அட்டை",
    "si": "පෙරනිමි: කාඩ්පත",
    "hi": "डिफ़ॉल्ट: कार्ड",
    "ar": "الافتراضي: بطاقة",
    "tr": "Varsayılan: Kart",
    "ru": "По умолчанию: карта",
    "zh": "默认：银行卡",
    "fr": "Par défaut : carte",
    "es": "Predeterminado: tarjeta"
  },
  "Unsere Lehrkräfte sind Muttersprachler – lerne authentisches Deutsch von Muttersprachlern.": {
    "en": "Our teachers are native speakers—learn authentic German directly from native speakers.",
    "ta": "எங்கள் ஆசிரியர்கள் ஜெர்மனைத் தாய்மொழியாகக் கொண்டவர்கள். அவர்களிடமிருந்து இயல்பான ஜெர்மன் மொழியைக் கற்றுக்கொள்ளுங்கள்.",
    "si": "අපගේ ගුරුවරු ජර්මන් මව් භාෂාව කතා කරති. ඔවුන්ගෙන් ස්වාභාවික ජර්මන් ඉගෙන ගන්න.",
    "hi": "हमारे शिक्षक जर्मन के मूल वक्ता हैं। उनसे वास्तविक जर्मन सीखें।",
    "ar": "مدرسونا ناطقون أصليون بالألمانية؛ تعلّم اللغة الأصيلة منهم مباشرةً.",
    "tr": "Öğretmenlerimiz Almancayı ana dili olarak konuşur; gerçek Almancayı doğrudan onlardan öğren.",
    "ru": "Наши преподаватели — носители немецкого; учитесь естественной речи у носителей языка.",
    "zh": "我们的教师以德语为母语，帮助您学习地道的德语。",
    "fr": "Nos professeurs sont de langue maternelle allemande. Apprenez un allemand authentique avec eux.",
    "es": "Nuestros profesores son hablantes nativos de alemán. Aprende alemán auténtico directamente con ellos."
  },
  "Deutsch lernen mit einem vollständigen interaktiven Kurs": {
    "en": "Learn German with a complete interactive course",
    "ta": "முழுமையான ஊடாடும் பாடநெறி மூலம் ஜெர்மன் கற்கவும்",
    "si": "සම්පූර්ණ අන්තර්ක්‍රියාකාරී පාඨමාලාවකින් ජර්මන් ඉගෙන ගන්න",
    "hi": "संपूर्ण इंटरैक्टिव पाठ्यक्रम से जर्मन सीखें",
    "ar": "تعلّم الألمانية بدورة تفاعلية كاملة",
    "tr": "Eksiksiz etkileşimli bir kursla Almanca öğren",
    "ru": "Изучайте немецкий на полном интерактивном курсе",
    "zh": "通过完整的互动课程学习德语",
    "fr": "Apprenez l’allemand avec un cours interactif complet",
    "es": "Aprende alemán con un curso interactivo completo"
  },
  "Sprechen, Hören, Lesen und Schreiben gezielt verbessern": {
    "en": "Improve speaking, listening, reading and writing",
    "ta": "பேசுதல், கேட்டல், வாசித்தல், எழுதுதல் ஆகிய திறன்களை மேம்படுத்துங்கள்",
    "si": "කතා කිරීම, ඇසීම, කියවීම සහ ලිවීම දියුණු කරන්න",
    "hi": "बोलने, सुनने, पढ़ने और लिखने की क्षमता बढ़ाएँ",
    "ar": "طوّر مهارات التحدث والاستماع والقراءة والكتابة",
    "tr": "Konuşma, dinleme, okuma ve yazma becerilerini geliştir",
    "ru": "Развивайте говорение, аудирование, чтение и письмо",
    "zh": "提高听、说、读、写能力",
    "fr": "Améliorez expression orale, écoute, lecture et écriture",
    "es": "Mejora expresión oral, comprensión auditiva, lectura y escritura"
  },
  "10 PDF-Lernbücher komplett kostenlos enthalten — im Wert von 100 €": {
    "en": "10 free PDF textbooks included—worth €100",
    "ta": "100 € மதிப்புள்ள 10 PDF பாடநூல்கள் இலவசமாகச் சேர்க்கப்பட்டுள்ளன",
    "si": "€100ක් වටිනා PDF පාඩම් පොත් 10ක් නොමිලේ ඇතුළත්",
    "hi": "€100 मूल्य की 10 PDF पाठ्यपुस्तकें निःशुल्क शामिल",
    "ar": "10 كتب PDF تعليمية مجانية بقيمة 100 يورو",
    "tr": "100 € değerinde 10 PDF ders kitabı ücretsiz",
    "ru": "10 бесплатных учебников PDF стоимостью 100 €",
    "zh": "免费包含价值 100 欧元的 10 本 PDF 教材",
    "fr": "10 manuels PDF gratuits d’une valeur de 100 €",
    "es": "10 manuales PDF gratuitos por valor de 100 €"
  },
  "1 Jahr kostenloser Premium-Zugang zur mobilen App inklusive": {
    "en": "Includes one free year of Premium access to the mobile app",
    "ta": "மொபைல் செயலிக்கான ஓராண்டு பிரீமியம் அணுகல் இலவசம்",
    "si": "ජංගම යෙදුමට වසරක නොමිලේ ප්‍රිමියම් ප්‍රවේශය ඇතුළත්",
    "hi": "मोबाइल ऐप का एक वर्ष प्रीमियम प्रवेश निःशुल्क शामिल",
    "ar": "يشمل سنة مجانية من الوصول المميز لتطبيق الهاتف",
    "tr": "Mobil uygulamada 1 yıl ücretsiz Premium erişim dâhil",
    "ru": "Год бесплатного Премиум-доступа в мобильном приложении",
    "zh": "包含移动应用一年的免费高级会员权限",
    "fr": "Un an d’accès Premium gratuit à l’application mobile inclus",
    "es": "Incluye un año de acceso prémium gratis a la app móvil"
  },
  "Starte noch heute deine Reise mit Deutsch. Sprich Deutsch mit Selbstvertrauen!": {
    "en": "Start your German journey today. Speak German with confidence!",
    "ta": "இன்றே ஜெர்மன் கற்றலைத் தொடங்குங்கள். தன்னம்பிக்கையுடன் ஜெர்மன் பேசுங்கள்!",
    "si": "අදම ජර්මන් ඉගෙනීම අරඹන්න. විශ්වාසයෙන් ජර්මන් කතා කරන්න!",
    "hi": "आज ही जर्मन सीखना शुरू करें। आत्मविश्वास से जर्मन बोलें!",
    "ar": "ابدأ رحلتك مع الألمانية اليوم. تحدث بثقة!",
    "tr": "Almanca yolculuğuna bugün başla. Özgüvenle Almanca konuş!",
    "ru": "Начните изучать немецкий сегодня. Говорите уверенно!",
    "zh": "今天就开始德语学习，自信地说德语！",
    "fr": "Commencez l’allemand aujourd’hui. Parlez avec confiance !",
    "es": "Empieza hoy a aprender alemán. ¡Habla con confianza!"
  },
  "Erweitere deinen Wortschatz und kommuniziere sicherer im Alltag.": {
    "en": "Expand your vocabulary and communicate more confidently in daily life.",
    "ta": "சொல்வளத்தை விரிவுபடுத்தி அன்றாட வாழ்க்கையில் தன்னம்பிக்கையுடன் பேசுங்கள்.",
    "si": "වචන දැනුම වැඩි කර දෛනික ජීවිතයේ විශ්වාසයෙන් සන්නිවේදනය කරන්න.",
    "hi": "शब्दावली बढ़ाएँ और रोज़मर्रा में अधिक आत्मविश्वास से संवाद करें।",
    "ar": "وسّع مفرداتك وتواصل بثقة أكبر في حياتك اليومية.",
    "tr": "Kelime dağarcığını genişlet ve günlük yaşamda daha güvenle iletişim kur.",
    "ru": "Расширяйте словарный запас и увереннее общайтесь в быту.",
    "zh": "扩大词汇量，更自信地进行日常交流。",
    "fr": "Enrichissez votre vocabulaire et communiquez avec plus d’aisance au quotidien.",
    "es": "Amplía tu vocabulario y comunícate con más confianza en el día a día."
  },
  "Meistere alltägliche Situationen und diskutiere über vertraute Themen.": {
    "en": "Master everyday situations and discuss familiar topics.",
    "ta": "அன்றாடச் சூழல்களைச் சமாளித்து பழக்கமான தலைப்புகளைப் பற்றி உரையாடுங்கள்.",
    "si": "දෛනික අවස්ථා කළමනාකරණය කර හුරුපුරුදු මාතෘකා ගැන සාකච්ඡා කරන්න.",
    "hi": "दैनिक परिस्थितियाँ सँभालें और परिचित विषयों पर चर्चा करें।",
    "ar": "أتقن المواقف اليومية وناقش مواضيع مألوفة.",
    "tr": "Günlük durumlarda ustalaş, tanıdık konularda konuş.",
    "ru": "Освойте повседневные ситуации и обсуждайте знакомые темы.",
    "zh": "掌握日常情境，讨论熟悉的话题。",
    "fr": "Maîtrisez les situations courantes et discutez de sujets familiers.",
    "es": "Domina situaciones cotidianas y debate temas conocidos."
  },
  "Verstehe komplexe Texte und diskutiere fließend über abstrakte Themen.": {
    "en": "Understand complex texts and discuss abstract topics fluently.",
    "ta": "சிக்கலான உரைகளைப் புரிந்துகொண்டு கருத்தியல் தலைப்புகளைச் சரளமாக விவாதியுங்கள்.",
    "si": "සංකීර්ණ පෙළ තේරුම් ගෙන සංකල්පමය මාතෘකා ගැන චතුර ලෙස සාකච්ඡා කරන්න.",
    "hi": "जटिल पाठ समझें और अमूर्त विषयों पर धाराप्रवाह चर्चा करें।",
    "ar": "افهم النصوص المعقدة وناقش المواضيع المجردة بطلاقة.",
    "tr": "Karmaşık metinleri anla ve soyut konuları akıcı biçimde tartış.",
    "ru": "Понимайте сложные тексты и свободно обсуждайте абстрактные темы.",
    "zh": "理解复杂文章，流利地讨论抽象话题。",
    "fr": "Comprenez les textes complexes et discutez avec fluidité de sujets abstraits.",
    "es": "Comprende textos complejos y habla con fluidez sobre temas abstractos."
  },
  "Karte": {
    "en": "Card",
    "ta": "அட்டை",
    "si": "කාඩ්පත",
    "hi": "कार्ड",
    "ar": "بطاقة",
    "tr": "Kart",
    "ru": "Карта",
    "zh": "银行卡",
    "fr": "Carte",
    "es": "Tarjeta"
  },
  "Kartenzahlung": {
    "en": "Card payment",
    "ta": "அட்டை மூலம் கட்டணம்",
    "si": "කාඩ්පත් ගෙවීම",
    "hi": "कार्ड भुगतान",
    "ar": "الدفع بالبطاقة",
    "tr": "Kartla ödeme",
    "ru": "Оплата картой",
    "zh": "银行卡付款",
    "fr": "Paiement par carte",
    "es": "Pago con tarjeta"
  },
  "Schnell bezahlen": {
    "en": "Pay quickly",
    "ta": "விரைவாகக் கட்டணம் செலுத்த",
    "si": "ඉක්මනින් ගෙවන්න",
    "hi": "जल्दी भुगतान करें",
    "ar": "ادفع بسرعة",
    "tr": "Hızlı öde",
    "ru": "Быстрая оплата",
    "zh": "快速付款",
    "fr": "Payer rapidement",
    "es": "Pagar rápidamente"
  },
  "Lastschrift": {
    "en": "Direct debit",
    "ta": "நேரடி வங்கிப் பிடித்தம்",
    "si": "සෘජු හර කිරීම",
    "hi": "प्रत्यक्ष डेबिट",
    "ar": "خصم مباشر",
    "tr": "Otomatik ödeme",
    "ru": "Прямое списание",
    "zh": "自动扣款",
    "fr": "Prélèvement automatique",
    "es": "Domiciliación bancaria"
  },
  "Überweisung": {
    "en": "Bank transfer",
    "ta": "வங்கிப் பரிமாற்றம்",
    "si": "බැංකු මාරුව",
    "hi": "बैंक ट्रांसफ़र",
    "ar": "تحويل بنكي",
    "tr": "Banka havalesi",
    "ru": "Банковский перевод",
    "zh": "银行转账",
    "fr": "Virement bancaire",
    "es": "Transferencia bancaria"
  },
  "Bankzahlung": {
    "en": "Bank payment",
    "ta": "வங்கி மூலம் கட்டணம்",
    "si": "බැංකු ගෙවීම",
    "hi": "बैंक भुगतान",
    "ar": "دفع بنكي",
    "tr": "Banka ödemesi",
    "ru": "Оплата через банк",
    "zh": "银行付款",
    "fr": "Paiement bancaire",
    "es": "Pago bancario"
  },
  "Schließen": {
    "en": "Close",
    "ta": "மூடுக",
    "si": "වසන්න",
    "hi": "बंद करें",
    "ar": "إغلاق",
    "tr": "Kapat",
    "ru": "Закрыть",
    "zh": "关闭",
    "fr": "Fermer",
    "es": "Cerrar"
  },
  "Zurück zu den Kursen": {
    "en": "Back to courses",
    "ta": "பாடநெறிகளுக்குத் திரும்ப",
    "si": "පාඨමාලා වෙත ආපසු",
    "hi": "पाठ्यक्रमों पर लौटें",
    "ar": "العودة إلى الدورات",
    "tr": "Kurslara dön",
    "ru": "Назад к курсам",
    "zh": "返回课程",
    "fr": "Retour aux cours",
    "es": "Volver a cursos"
  },

  // Screensaver typewriter: German-first editorial messages in all 10 website languages.
  "Deutsch öffnet neue Türen.": {
    "en": "German opens new doors.",
    "ta": "ஜெர்மன் மொழி புதிய வாய்ப்புகளைத் திறக்கிறது.",
    "si": "ජර්මානු භාෂාව නව අවස්ථා විවර කරයි.",
    "hi": "जर्मन भाषा नए अवसरों के द्वार खोलती है।",
    "ar": "اللغة الألمانية تفتح أبوابًا جديدة.",
    "tr": "Almanca yeni kapılar açar.",
    "ru": "Немецкий язык открывает новые двери.",
    "zh": "德语为你打开新的大门。",
    "fr": "L’allemand ouvre de nouvelles portes.",
    "es": "El alemán abre nuevas puertas."
},
  "Dein Deutsch. Deine Zukunft.": {
    "en": "Your German. Your future.",
    "ta": "உங்கள் ஜெர்மன் மொழி. உங்கள் எதிர்காலம்.",
    "si": "ඔබේ ජර්මානු දැනුම. ඔබේ අනාගතය.",
    "hi": "आपकी जर्मन। आपका भविष्य।",
    "ar": "ألمانيتك. مستقبلك.",
    "tr": "Senin Almancan. Senin geleceğin.",
    "ru": "Твой немецкий. Твоё будущее.",
    "zh": "你的德语，你的未来。",
    "fr": "Votre allemand. Votre avenir.",
    "es": "Tu alemán. Tu futuro."
},
  "Worte werden zu Möglichkeiten.": {
    "en": "Words become opportunities.",
    "ta": "சொற்கள் வாய்ப்புகளாக மாறுகின்றன.",
    "si": "වචන අවස්ථා බවට පත්වේ.",
    "hi": "शब्द अवसरों में बदल जाते हैं।",
    "ar": "الكلمات تتحول إلى فرص.",
    "tr": "Kelimeler fırsatlara dönüşür.",
    "ru": "Слова превращаются в возможности.",
    "zh": "让词语化为机遇。",
    "fr": "Les mots deviennent des opportunités.",
    "es": "Las palabras se convierten en oportunidades."
},
  "Sprich mit Selbstvertrauen.": {
    "en": "Speak with confidence.",
    "ta": "தன்னம்பிக்கையுடன் பேசுங்கள்.",
    "si": "ආත්ම විශ්වාසයෙන් කතා කරන්න.",
    "hi": "आत्मविश्वास के साथ बोलें।",
    "ar": "تحدث بثقة.",
    "tr": "Özgüvenle konuş.",
    "ru": "Говори уверенно.",
    "zh": "自信地开口说。",
    "fr": "Parlez avec assurance.",
    "es": "Habla con confianza."
},
};
